/**
 * Created by Alexandr on 23.07.2017.
 */

;(function () {

    "use strict";

    function users ($localStorage, $state, http, url, authUser) {

        // servise which work with auth and send request on server

        var service = {

            logout      :  logout,
            forgotPassword      :  forgotPassword,
            customersBalance:customersBalance,
            setLanguage:setLanguage,
            messageToAdmin: messageToAdmin,
        };

        return service;

        function customersBalance(data, dinamic_url) {
            return http.get(url.users.customers.balance, data, dinamic_url)
                .then(function (res) {
                    return res.data;
                });
        };


        function forgotPassword(data, dinamic_url) {
            return http.put(url.users.forgotPassword, data, dinamic_url)
                .then(function (res) {
                    return res.data;
                });
        };

        function logout(data) {
            return http.post(url.users.logout, data)
                .then(function (res) {
                    delete $localStorage["pestContrlCust.authorizationData"];
                    delete  $localStorage["pestContrlCust.lang"];
                    authUser.setData({});
                    $state.go('login');
                    return res.data;
                });
        };

        function setLanguage(data, dinamic_url) {
            return http.put(url.users.setLanguage, data, dinamic_url)
                .then(function (res) {
                    return res.data;
                });
        };

      /**
       *
       * @param data Payload
       * @param string data.message
       * @return {*}
       */
        function messageToAdmin(data) {
          return http.post(url.users.messageToAdmin, data)
            .then(function (res) {
              return res.data;
            });
        }
    };

    users.$inject = ['$localStorage', '$state', 'http', 'url', 'authUser'];
    angular.module('model.users', []).factory('users', users);

})();

/**
 * Created by Alexandr on 23.07.2017.
 */

;(function () {

    "use strict";

    function stocks ($localStorage, $state, http, url) {

        // servise which work with auth and send request on server

        var service = {
            doctorStockSettings:doctorStockSettings,
            doctorStockSettingsPut:doctorStockSettingsPut,
            stockBranches:stockBranches,
            stockSections:stockSections,


        };

        return service;


        function doctorStockSettings(data, dinamic_url) {
            return http.get(url.stocks.doctorStockSettings, data, dinamic_url)
                .then(function (res) {
                    return res.data;
                });
        };

        function doctorStockSettingsPut(data, dinamic_url) {
            return http.put(url.stocks.doctorStockSettings, data, dinamic_url)
                .then(function (res) {
                    return res.data;
                });
        };

        function stockBranches(data, dinamic_url) {
            return http.get(url.stocks.stockBranches, data, dinamic_url)
                .then(function (res) {
                    return res.data;
                });
        };


        function stockSections(data, dinamic_url) {
            return http.get(url.stocks.stockSections, data, dinamic_url)
                .then(function (res) {
                    return res.data;
                });
        };





    };

    stocks.$inject = ['$localStorage', '$state', 'http', 'url'];
    angular.module('model.stocks', []).factory('stocks', stocks);

})();

/**
 * Created by Alexandr on 23.07.2017.
 */

;(function () {

    "use strict";

    function rb (http, url) {

        // servise which work with auth and send request on server

        var service = {
            get_public_settings:get_public_settings,


        };

        return service;


        function get_public_settings(data, dinamic_url) {
            return http.post(url.rb.get_public_settings, data, dinamic_url)
                .then(function (res) {
                    return res.data;
                });
        };






    };

    rb.$inject = ['http', 'url'];
    angular.module('model.rb', []).factory('rb', rb);

})();

/**
 * Created by alex on 29.03.2017.
 */


;(function () {

    "use strict";

    function auth ($localStorage, $sessionStorage, http, url, authUser, $state) {

        // servise which work with auth and send request on server

        var service = {
            login      :  login,
            logout      :  logout
        };

        return service;


        function login(data) {
            return http.post(url.auth.login, data)
                .then(function (res) {
                    return res.data;
                });
        };

        function logout(data) {
                    // delete $localStorage["pestContrlCust.authorizationData"];
                    // authUser.setData({});
                    // $state.go('login');
        };




    };

    auth.$inject = ['$localStorage', '$sessionStorage', 'http', 'url', 'authUser', '$state'];
    angular.module('model.auth', []).factory('auth', auth);

})();

/**
 * Created by Alexandr on 23.07.2017.
 */

;(function () {

  "use strict";

  function appointments(http, url, $rootScope) {

    var service = {
      work_list: work_list,
      getListDocuments: getListDocuments,
      getDocument: getDocument,
      getInvoicesList: getInvoicesList,
      getInvoiceDocument: getInvoiceDocument
    };

    return service;

    function _getClientIDFromRootScope() {
      var userObj = typeof $rootScope.user === 'object' ? $rootScope.user : {};
      return typeof userObj.user_id !== 'undefined' ? userObj.user_id : null;
    }

    function getInvoicesList(data) {
      data = data || {};
      var client_id = _getClientIDFromRootScope();

      if (client_id !== null) {
        data.client_id = client_id;
      }

      return http.get(url.appointments.getInvoicesList, data)
        .then(function (res) {
          return res.data;
        });
    }

    function getListDocuments(data) {
      data = data || {};
      var client_id = _getClientIDFromRootScope();

      if (client_id !== null) {
        data.client_id = client_id;
      }

      return http.get(url.appointments.getListDocuments, data)
        .then(function (res) {
          return res.data;
        });
    }

    function work_list(data, dinamic_url) {
      data = data || {};
      var client_id = _getClientIDFromRootScope();

      if (client_id !== null) {
        data.client_id = client_id;
      }

      return http.get(url.appointments.work_list, data, dinamic_url)
        .then(function (res) {
          return res.data;
        });
    };

    // put 'blob' for responseType in $http
    function getDocument(id, isImage) {
      return http.get(
        url.appointments.getDocument + id + '?isImage=' + (isImage ? 'true' : 'false'),
        { responseType: 'blob' })
        .then(function (res) {
          return res;
        });
    };

    function getInvoiceDocument(id) {
      return http.get(
        url.appointments.getInvoiceDocument + id,
        {responseType: 'blob' });
    };
  };

  appointments.$inject = ['http', 'url', '$rootScope'];
  angular.module('model.appointments', []).factory('appointments', appointments);

})();

/**
 * Created by alex on 13.04.2017.
 */



;(function () {

    "use strict";

     function translate ($rootScope, $translate, $localStorage) {

         var service = {
             start      : start,
             change      : change,
             getCurrent : getCurrent
         };

         return service;


         function start(res) {

             if ($localStorage["pestContrlCust.lang"]){
                 var lang = $localStorage["pestContrlCust.lang"];
             } else {
                 var lang = 'he';
             }

             change(lang);

             // $rootScope.settings = res.data.settings;
             // var lang = $rootScope.settings.language  === 'he' ? 'he' : $rootScope.settings.language;
             // $translate.use(lang);


         }


         function getCurrent (lang) {

             if (!$localStorage["pestContrlCust.lang"]){
                 $localStorage["pestContrlCust.lang"] = lang;
             }
         }


         function change(lang) {

             $rootScope.settings = {
                 "language":lang,
                 "rtl_ltr": (lang == 'he') ?  'rtl' : 'ltr'
             };
             var lang = ($rootScope.settings.language  === 'he') ? 'he' : $rootScope.settings.language;
             $translate.use(lang);

             $localStorage["pestContrlCust.lang"] = lang;
         }
    };

    translate.$inject = ['$rootScope', '$translate', '$localStorage'];
    angular.module('model.translate', []).factory('translate', translate);

})();
/**
 * Created by Alexandr on 30.07.2017.
 */


;(function () {

    "use strict";

    function goodAlert (SweetAlert) {

        var service = {

            change: change
        };

        return service;

        function change (items, collback) {

            var text = "Save changes?"




            var confirmButtonColor = "#618a0a";

            SweetAlert.swal({
                    title: "Are you sure?",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: confirmButtonColor,
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (!isConfirm) {
                        var nameAction = 'cancel';
                        collback(items, nameAction);
                    } else {
                        var nameAction = 'confirm';
                        collback(items, nameAction);
                    }
                });
        }



    }




    goodAlert.$inject = ['SweetAlert'];
    angular.module('model.goodAlert', []).factory('goodAlert', goodAlert);

})();
/**
 * Created by alex on 13.04.2017.
 */



;(function () {

    "use strict";

     function credentials ($state, authUser) {

         var service = {
             authorized      : authorized,
         };

         return service;



         function authorized(toState) {
             if (
                 // User isn’t authenticated
             (toState.auth &&
             !authUser.data.access_token) ||
             // User authenticated
             (  !toState.auth &&
             authUser.data.access_token)
             ) {
                 return false;
             } else {
                 return true
             }
         }
    };

    credentials.$inject = ['$state', 'authUser'];
    angular.module('model.credentials', []).factory('credentials', credentials);

})();
/**
 * Created by Alexandr on 23.07.2017.
 */


;(function () {

    "use strict";

    function authUser ($localStorage, $rootScope) {



        if ($localStorage["pestContrlCust.authorizationData"]){
            var data = $localStorage["pestContrlCust.authorizationData"];
        } else {
            var data = {};
        }



        var service = {
            data      : data,

            setData   : setData,
            getData   : getData,

        };

        return service;



        function setData(data) {
            if (Object.keys(data).length !== 0){
                this.data = data;
                $localStorage["pestContrlCust.authorizationData"] = data;
                $rootScope.userModel = data;
            } else {
                this.data ={};
                delete $localStorage["pestContrlCust.authorizationData"];
            }

        }
        function getData(item) {
             return this.data[item];
        }

    };

    authUser.$inject = ['$localStorage', '$rootScope'];
    angular.module('model.authUser', []).factory('authUser', authUser);

})();
(function() {
  'use strict';



  angular
    .module('inspinia', [

        //Main
        'app.directives',
        'app.filters',
        'app.request',
        'app.services',


        // Thirty part
        'ngAnimate',
        'ngTouch',
        'ngSanitize',
        'ngAria',
        'ngMessages',
        'ui.router',
        'ui.bootstrap',
        'cgNotify',
        'oitozero.ngSweetAlert',
        'ngStorage',
        'toastr',
        'ngDialog',
        'pascalprecht.translate',
        'ngFileSaver'
    ]);

})();

(function () {
  'use strict';

  function WorkListController(goodAlert, toastr, $document, $window, getWorkList, appointments, $rootScope, $translate, $scope) {

    var vm = this;

    vm.worklist = getWorkList.worklist;

    vm.getDocument = getDocument;

    activate()

    function activate() {
      vm.worklist.forEach(
        function (item) {
          item.isPDFGenerated = item.isPDFGenerated ? true : false;
          item.servicesPC = item.main.slice();
          item.materialsPC2 = item.materials.slice(1);
          item.additional.forEach(function (innerItem) {
            item.servicesPC.push(innerItem)
          })
          item.servicesPC2 = item.servicesPC.slice(1);
          item.servicesMaterials2 = [];

          var length = (item.materialsPC2.length > item.servicesPC2.length) ? item.materialsPC2.length : item.servicesPC2.length;
          for (var i = 0; i < length; i++)
            item.servicesMaterials2.push({
              "materialsPC2": item.materialsPC2[i],
              "servicesPC2": item.servicesPC2[i]
            })


        }
      )

    }

    function getDocument(item) {
      appointments.getDocument(null, [item.AppID]).then(
        function (res) {


          // var headers = response.headers();
          //  var file = new Blob([response.data], {type: headers['content-type']});

          var file = res;


          $translate('Invoice/Receipt').then(function (translation) {
            var name = translation;
            saveAs(file, name || 'no name');
          }, function (defaultTranslate) {
            saveAs(file, defaultTranslate || 'no name');
          });


        }
      )

    }


    $scope.$on('changeUser', function (event, data) {
      var d = new Date();
      getDate(d);
      appointments.work_list({
        "appointments_date": getDate(d),
        "current_time": getTime(d),
        "mode": "client",
        client_id: data.user_id
      })
        .then(
          function (res) {
            vm.worklist = res.data.worklist;
            activate();
          }
        )


      function getDate(date) {

        var dd = date.getDate();
        if (dd < 10) dd = '0' + dd;

        var mm = date.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;

        var yy = date.getFullYear() % 100;
        if (yy < 10) yy = '0' + yy;

        return mm + '/' + dd + '/' + yy;
      };

      function getTime(date) {
        var hours = date.getHours();
        if (hours < 10) hours = '0' + hours;
        var minutes = date.getMinutes();
        if (minutes < 10) minutes = '0' + minutes;

        return hours + ':' + minutes;
      }
    });


  }

  WorkListController.$inject = ['goodAlert', 'toastr', '$document', '$window', 'getWorkList', 'appointments', '$rootScope', '$translate', '$scope'];
  angular.module('inspinia').controller('WorkListController', WorkListController);
})();

(function () {
  'use strict';

  function TabsController($scope, $state) {
    var vm = this;
    // vm.currentSate = $state.current.name;

    vm.tabs = {
      'appointments': {
        id: 'appointments',
        title: 'Appointments',
        iconClass: "fa-calendar",
        isActive: 1,
        state: "index.tabs.appointments"
      },
      'documents': {
        id: 'documents',
        title: 'Documents',
        iconClass: "fa-briefcase",
        isActive: 0,
        state: "index.tabs.documents"
      },
      'invoices': {
        id: 'invoices',
        title: 'Invoices',
        iconClass: "fa-file-pdf-o",
        isActive: 0,
        state: "index.tabs.invoices"
      },
    };
    vm.switchTab = function(tabObj) {
      Array.prototype.map.call(Object.keys(vm.tabs), function(key){
        if(vm.tabs[key].id === tabObj.id) {
          vm.tabs[key].isActive = 1;
        } else {
          vm.tabs[key].isActive = 0;
        }
      });
    }
  }

  TabsController.$inject = [
    '$scope',
    '$state'
  ];
  angular.module('inspinia').controller('TabsController', TabsController);
})();


(function () {
    'use strict';

    function InvoicesController($scope, getInvoicesList, appointments, SweetAlert, $translate, $q) {
        var vm = this;
        vm.appointments = appointments;
        vm.getDocument = getDocument;
        setList(getInvoicesList);

        function setList(resp) {
          vm.list = typeof resp === 'object' && resp.invoices ? resp.invoices : [];
        }


      $scope.$on('changeUser', function (event, data) {
        vm.appointments.getInvoicesList({
          mode: "client",
          client_id: data.user_id
        })
          .then(
            function (resp) {
              var data = typeof resp === "object" && Object.keys(resp.data).length > 0 ? resp.data : null;
              setList(data);
            }
          );
      });

        function getDocument(item) {
          appointments.getInvoiceDocument(item.documentID).then(function (response) {
            var fileType = mime.getType(response.fileName);
            var blob = new Blob([response.data], { type: fileType });
            var fileURL = URL.createObjectURL(blob);
            var element = document.createElement('a');
            if (fileType !== 'image/png' && fileType !== 'image/jpg' && fileType !== 'image/jpeg' && fileType !== 'application/pdf') {
              element.setAttribute('download', response.fileName);
            }
            document.body.appendChild(element);
            element.href = fileURL;
            element.click();
            document.body.removeChild(element);
          }, function(e) {
            var title = 'Error';
            var m = 'Sorry, something went wrong!';

            if(e.status === 404) {
              title = 'Not Found';
              m = 'Sorry, file was not found!';
            }

            $q.all([
              $translate([title, m]),
            ]).then(function (tList) {
              try {
                if (!Array.isArray(tList)) {
                  throw new Error('Translation was failed!');
                }

                if (typeof tList[0] === 'undefined' || Object.keys(tList[0]).length === 0)  {
                  throw new Error('Translation was failed!');
                }

                if (typeof tList[0][title] !== "string" || typeof tList[0][m] !== "string") {
                  throw new Error('Translation was not passed properly!');
                }

                SweetAlert.error(tList[0][title], tList[0][m]);
              } catch (e) {
                debugger;
                SweetAlert.error(title, m);
              }
            }, function (e) {
              SweetAlert.error(title, m);
            });
          });
        }
    }

  InvoicesController.$inject = ['$scope', 'getInvoicesList', 'appointments', 'SweetAlert', '$translate', '$q'];
  angular.module('inspinia').controller('InvoicesController', InvoicesController);
})();

(function () {
  'use strict';

  function DocumentsController($scope, $state, getListResponse, appointments, SweetAlert, $translate, $q) {
    var vm = this;
    vm.appointments = appointments;
    vm.getDocument = getDocument;
    setList(getListResponse);

    function setList(resp) {
      vm.list = typeof resp === 'object' && resp.documents ? resp.documents : [];
    }

    function getDocument(item) {
      vm.appointments.getDocument(item.id, item.image).then(function(response){
        var fileType = mime.getType(response.fileName);
        var blob = new Blob([response.data], { type: fileType });
        var fileURL = URL.createObjectURL(blob);
        var element = document.createElement('a');
        if (fileType !== 'image/png' && fileType !== 'image/jpg' && fileType !== 'image/jpeg' && fileType !== 'application/pdf') {
          element.setAttribute('download', response.fileName);
        }
        element.style.display = 'none';
        document.body.appendChild(element);
        element.href = fileURL;
        element.click();
        document.body.removeChild(element);
      }, function (e) {
        var title = 'Error';
        var m = 'Sorry, something went wrong!';

        if(e.status === 404) {
          title = 'Not Found';
          m = 'Sorry, file was not found!';
        }

        $q.all([
          $translate([title, m]),
        ]).then(function (tList) {
          try {
            if (!Array.isArray(tList)) {
              throw new Error('Translation was failed!');
            }

            if (typeof tList[0] === 'undefined' || Object.keys(tList[0]).length === 0)  {
              throw new Error('Translation was failed!');
            }

            if (typeof tList[0][title] !== "string" || typeof tList[0][m] !== "string") {
              throw new Error('Translation was not passed properly!');
            }

            SweetAlert.error(tList[0][title], tList[0][m]);
          } catch (e) {
            SweetAlert.error(title, m);
          }

        }, function (e) {
          console.error(e);
          SweetAlert.error(title, m);
        });
      });
    }

    $scope.$on('changeUser', function (event, data) {
      vm.appointments.getListDocuments({
        mode: "client",
        client_id: data.user_id
      })
        .then(
          function (resp) {
            var data = typeof resp === "object" && Object.keys(resp.data).length > 0 ? resp.data : null;
            setList(data);
          }
        );
    });
  }

  DocumentsController.$inject = ['$scope', '$state', 'getListResponse', 'appointments', 'SweetAlert', '$translate', '$q'];
  angular.module('inspinia').controller('DocumentsController', DocumentsController);
})();


(function () {
    'use strict';

  function AppointmentsController(goodAlert, toastr, $document, $window, getWorkList, appointments, $rootScope, $translate, $scope) {

    var vm = this;

    vm.worklist = getWorkList.worklist;

    vm.getDocument = getDocument;

    activate()

    function activate() {
      vm.worklist.forEach(
        function (item) {
          item.isPDFGenerated = item.isPDFGenerated ? true : false;
          item.servicesPC = item.main.slice();
          item.materialsPC2 = item.materials.slice(1);
          item.additional.forEach(function (innerItem) {
            item.servicesPC.push(innerItem)
          })
          item.servicesPC2 = item.servicesPC.slice(1);
          item.servicesMaterials2 = [];

          var length = (item.materialsPC2.length > item.servicesPC2.length) ? item.materialsPC2.length : item.servicesPC2.length;
          for (var i = 0; i < length; i++)
            item.servicesMaterials2.push({
              "materialsPC2": item.materialsPC2[i],
              "servicesPC2": item.servicesPC2[i]
            })


        }
      )

    }

    function getDocument(item) {
      appointments.getDocument(null, [item.AppID]).then(
        function (res) {


          // var headers = response.headers();
          //  var file = new Blob([response.data], {type: headers['content-type']});

          var file = res;


          $translate('Invoice/Receipt').then(function (translation) {
            var name = translation;
            saveAs(file, name || 'no name');
          }, function (defaultTranslate) {
            saveAs(file, defaultTranslate || 'no name');
          });


        }
      )

    }


    $scope.$on('changeUser', function (event, data) {
      var d = new Date();
      getDate(d);
      appointments.work_list({
        "appointments_date": getDate(d),
        "current_time": getTime(d),
        "mode": "client",
        client_id: data.user_id
      })
        .then(
          function (res) {
            vm.worklist = res.data.worklist;
            activate();
          }
        )


      function getDate(date) {

        var dd = date.getDate();
        if (dd < 10) dd = '0' + dd;

        var mm = date.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;

        var yy = date.getFullYear() % 100;
        if (yy < 10) yy = '0' + yy;

        return mm + '/' + dd + '/' + yy;
      };

      function getTime(date) {
        var hours = date.getHours();
        if (hours < 10) hours = '0' + hours;
        var minutes = date.getMinutes();
        if (minutes < 10) minutes = '0' + minutes;

        return hours + ':' + minutes;
      }
    });


  }

  AppointmentsController.$inject = ['goodAlert', 'toastr', '$document', '$window', 'getWorkList', 'appointments', '$rootScope', '$translate', '$scope'];
  angular.module('inspinia').controller('AppointmentsController', AppointmentsController);
})();






(function () {
    'use strict';
    function LoginController($state, toastr, auth, authUser, $rootScope, $translate, users, translate, $localStorage) {

        var vm = this;
        vm.user = {};
        vm.login = login;
        vm.changeLanguage = changeLanguage;
        vm.forgotPassword = forgotPassword;
        vm.forgotFormShow = false;
        // vm.admin_welcome_title = "Welcome to Administration <br> Panel PestControl";
        // vm.admin_welcome_text = "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium";

        vm.user.is_stock_admin = 0;

// // function for login
        function login() {


            if (vm.form.username.$error.required) {

                    $translate("Email field can't be blank").then(function (translation) {
                        toastr.error(translation, {timeOut: 3000});
                        return;
                    }, function (defaultTranslate) {
                        toastr.error(defaultTranslate, {timeOut: 3000});
                        return;
                    });


            }
            else if (vm.form.password.$error.required) {


                $translate("Password field can't be blank").then(function (translation) {
                    toastr.error(translation, {timeOut: 3000});
                    return;
                }, function (defaultTranslate) {
                    toastr.error(defaultTranslate, {timeOut: 3000});
                    return;
                });

            }


            if (vm.form.$invalid) { return; }


            auth.login(vm.user).then(function(data){
                authUser.setData(data.data.user);
                translate.getCurrent($translate.use());
                users.setLanguage({language:$localStorage["pestContrlCust.lang"]}).then(
                    function(res){
                        $state.go('index.tabs.appointments');
                    }
                )

            }, function (response){
                if (response.data.error && [2015, 2017, 2043, 2900].indexOf(response.data.error.code) !== -1 ){
                    var message = response.data.validation_Error ? response.data.validation_Error : response.data.error.message;
                    translateServer(message);
                    return false;
                }
            })

        }





        function forgotPassword() {
            var user;

            if (vm.formForgot.email.$error.required) {

                $translate("Email field can't be blank").then(function (translation) {
                    toastr.error(translation, {timeOut: 3000});
                    return;
                }, function (defaultTranslate) {
                    toastr.error(defaultTranslate, {timeOut: 3000});
                    return;
                });


            }



            if (vm.formForgot.$invalid) { return; }
             user = jQuery.extend(true, {}, vm.user);
            user.language = $localStorage["pestContrlCust.lang"];

            users.forgotPassword(user).then(function(data){
                vm.forgotFormShow = false;

                $translate("Please check your email").then(function (translation) {
                    toastr.success(translation, {timeOut: 3000});
                    return;
                }, function (defaultTranslate) {
                    toastr.success(defaultTranslate, {timeOut: 3000});
                    return;
                });
            }, function (response){


                if (response.data.error && [2015, 2017, 2043, 2900].indexOf(response.data.error.code) !== -1 ){
                    var message = response.data.validation_Error ? response.data.validation_Error : response.data.error.message;
                    translateServer(message);
                    return false;
                }



            })


        }

        function translateServer(validation_Error) {
            $translate(validation_Error).then(function (translation) {
                toastr.error(translation, {timeOut: 3000});
                return;
            }, function (defaultTranslate) {
                toastr.error(defaultTranslate, {timeOut: 3000});
                return;
            });

        }


        function changeLanguage (lang) {

            translate.change(lang);
        }









    }

    LoginController.$inject = ['$state', 'toastr', 'auth', 'authUser', '$rootScope', '$translate', 'users', 'translate', '$localStorage'];
    angular.module('inspinia').controller('LoginController', LoginController);
})();

!function (a) {
  if ("object" == typeof exports && "undefined" != typeof module) module.exports = a(); else if ("function" == typeof define && define.amd) define([], a); else {
    ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).mime = a()
  }
}(function () {
  return function () {
    return function a(i, p, n) {
      function t(l, c) {
        if (!p[l]) {
          if (!i[l]) {
            var e = "function" == typeof require && require;
            if (!c && e) return e(l, !0);
            if (o) return o(l, !0);
            var d = new Error("Cannot find module '" + l + "'");
            throw d.code = "MODULE_NOT_FOUND", d
          }
          var s = p[l] = {exports: {}};
          i[l][0].call(s.exports, function (a) {
            return t(i[l][1][a] || a)
          }, s, s.exports, a, i, p, n)
        }
        return p[l].exports
      }

      for (var o = "function" == typeof require && require, l = 0; l < n.length; l++) t(n[l]);
      return t
    }
  }()({
    1: [function (a, i, p) {
      "use strict";

      function n() {
        this._types = Object.create(null), this._extensions = Object.create(null);
        for (var a = 0; a < arguments.length; a++) this.define(arguments[a]);
        this.define = this.define.bind(this), this.getType = this.getType.bind(this), this.getExtension = this.getExtension.bind(this)
      }

      n.prototype.define = function (a, i) {
        for (var p in a) {
          for (var n = a[p], t = 0; t < n.length; t++) {
            if ("*" != (o = n[t])[0]) {
              if (!i && o in this._types) throw new Error('Attempt to change mapping for "' + o + '" extension from "' + this._types[o] + '" to "' + p + '". Pass `force=true` to allow this, otherwise remove "' + o + '" from the list of extensions for "' + p + '".');
              this._types[o] = p
            }
          }
          if (i || !this._extensions[p]) {
            var o = n[0];
            this._extensions[p] = "*" != o[0] ? o : o.substr(1)
          }
        }
      }, n.prototype.getType = function (a) {
        var i = (a = String(a)).replace(/^.*[\/\\]/, "").toLowerCase(), p = i.replace(/^.*\./, "").toLowerCase(),
          n = i.length < a.length;
        return (p.length < i.length - 1 || !n) && this._types[p] || null
      }, n.prototype.getExtension = function (a) {
        return (a = /^\s*([^;\s]*)/.test(a) && RegExp.$1) && this._extensions[a.toLowerCase()] || null
      }, i.exports = n
    }, {}], 2: [function (a, i, p) {
      "use strict";
      var n = a("./Mime");
      i.exports = new n(a("./types/standard"), a("./types/other"))
    }, {"./Mime": 1, "./types/other": 3, "./types/standard": 4}], 3: [function (a, i, p) {
      i.exports = {
        "application/prs.cww": ["cww"],
        "application/vnd.3gpp.pic-bw-large": ["plb"],
        "application/vnd.3gpp.pic-bw-small": ["psb"],
        "application/vnd.3gpp.pic-bw-var": ["pvb"],
        "application/vnd.3gpp2.tcap": ["tcap"],
        "application/vnd.3m.post-it-notes": ["pwn"],
        "application/vnd.accpac.simply.aso": ["aso"],
        "application/vnd.accpac.simply.imp": ["imp"],
        "application/vnd.acucobol": ["acu"],
        "application/vnd.acucorp": ["atc", "acutc"],
        "application/vnd.adobe.air-application-installer-package+zip": ["air"],
        "application/vnd.adobe.formscentral.fcdt": ["fcdt"],
        "application/vnd.adobe.fxp": ["fxp", "fxpl"],
        "application/vnd.adobe.xdp+xml": ["xdp"],
        "application/vnd.adobe.xfdf": ["xfdf"],
        "application/vnd.ahead.space": ["ahead"],
        "application/vnd.airzip.filesecure.azf": ["azf"],
        "application/vnd.airzip.filesecure.azs": ["azs"],
        "application/vnd.amazon.ebook": ["azw"],
        "application/vnd.americandynamics.acc": ["acc"],
        "application/vnd.amiga.ami": ["ami"],
        "application/vnd.android.package-archive": ["apk"],
        "application/vnd.anser-web-certificate-issue-initiation": ["cii"],
        "application/vnd.anser-web-funds-transfer-initiation": ["fti"],
        "application/vnd.antix.game-component": ["atx"],
        "application/vnd.apple.installer+xml": ["mpkg"],
        "application/vnd.apple.keynote": ["keynote"],
        "application/vnd.apple.mpegurl": ["m3u8"],
        "application/vnd.apple.numbers": ["numbers"],
        "application/vnd.apple.pages": ["pages"],
        "application/vnd.apple.pkpass": ["pkpass"],
        "application/vnd.aristanetworks.swi": ["swi"],
        "application/vnd.astraea-software.iota": ["iota"],
        "application/vnd.audiograph": ["aep"],
        "application/vnd.blueice.multipass": ["mpm"],
        "application/vnd.bmi": ["bmi"],
        "application/vnd.businessobjects": ["rep"],
        "application/vnd.chemdraw+xml": ["cdxml"],
        "application/vnd.chipnuts.karaoke-mmd": ["mmd"],
        "application/vnd.cinderella": ["cdy"],
        "application/vnd.citationstyles.style+xml": ["csl"],
        "application/vnd.claymore": ["cla"],
        "application/vnd.cloanto.rp9": ["rp9"],
        "application/vnd.clonk.c4group": ["c4g", "c4d", "c4f", "c4p", "c4u"],
        "application/vnd.cluetrust.cartomobile-config": ["c11amc"],
        "application/vnd.cluetrust.cartomobile-config-pkg": ["c11amz"],
        "application/vnd.commonspace": ["csp"],
        "application/vnd.contact.cmsg": ["cdbcmsg"],
        "application/vnd.cosmocaller": ["cmc"],
        "application/vnd.crick.clicker": ["clkx"],
        "application/vnd.crick.clicker.keyboard": ["clkk"],
        "application/vnd.crick.clicker.palette": ["clkp"],
        "application/vnd.crick.clicker.template": ["clkt"],
        "application/vnd.crick.clicker.wordbank": ["clkw"],
        "application/vnd.criticaltools.wbs+xml": ["wbs"],
        "application/vnd.ctc-posml": ["pml"],
        "application/vnd.cups-ppd": ["ppd"],
        "application/vnd.curl.car": ["car"],
        "application/vnd.curl.pcurl": ["pcurl"],
        "application/vnd.dart": ["dart"],
        "application/vnd.data-vision.rdz": ["rdz"],
        "application/vnd.dece.data": ["uvf", "uvvf", "uvd", "uvvd"],
        "application/vnd.dece.ttml+xml": ["uvt", "uvvt"],
        "application/vnd.dece.unspecified": ["uvx", "uvvx"],
        "application/vnd.dece.zip": ["uvz", "uvvz"],
        "application/vnd.denovo.fcselayout-link": ["fe_launch"],
        "application/vnd.dna": ["dna"],
        "application/vnd.dolby.mlp": ["mlp"],
        "application/vnd.dpgraph": ["dpg"],
        "application/vnd.dreamfactory": ["dfac"],
        "application/vnd.ds-keypoint": ["kpxx"],
        "application/vnd.dvb.ait": ["ait"],
        "application/vnd.dvb.service": ["svc"],
        "application/vnd.dynageo": ["geo"],
        "application/vnd.ecowin.chart": ["mag"],
        "application/vnd.enliven": ["nml"],
        "application/vnd.epson.esf": ["esf"],
        "application/vnd.epson.msf": ["msf"],
        "application/vnd.epson.quickanime": ["qam"],
        "application/vnd.epson.salt": ["slt"],
        "application/vnd.epson.ssf": ["ssf"],
        "application/vnd.eszigno3+xml": ["es3", "et3"],
        "application/vnd.ezpix-album": ["ez2"],
        "application/vnd.ezpix-package": ["ez3"],
        "application/vnd.fdf": ["fdf"],
        "application/vnd.fdsn.mseed": ["mseed"],
        "application/vnd.fdsn.seed": ["seed", "dataless"],
        "application/vnd.flographit": ["gph"],
        "application/vnd.fluxtime.clip": ["ftc"],
        "application/vnd.framemaker": ["fm", "frame", "maker", "book"],
        "application/vnd.frogans.fnc": ["fnc"],
        "application/vnd.frogans.ltf": ["ltf"],
        "application/vnd.fsc.weblaunch": ["fsc"],
        "application/vnd.fujitsu.oasys": ["oas"],
        "application/vnd.fujitsu.oasys2": ["oa2"],
        "application/vnd.fujitsu.oasys3": ["oa3"],
        "application/vnd.fujitsu.oasysgp": ["fg5"],
        "application/vnd.fujitsu.oasysprs": ["bh2"],
        "application/vnd.fujixerox.ddd": ["ddd"],
        "application/vnd.fujixerox.docuworks": ["xdw"],
        "application/vnd.fujixerox.docuworks.binder": ["xbd"],
        "application/vnd.fuzzysheet": ["fzs"],
        "application/vnd.genomatix.tuxedo": ["txd"],
        "application/vnd.geogebra.file": ["ggb"],
        "application/vnd.geogebra.tool": ["ggt"],
        "application/vnd.geometry-explorer": ["gex", "gre"],
        "application/vnd.geonext": ["gxt"],
        "application/vnd.geoplan": ["g2w"],
        "application/vnd.geospace": ["g3w"],
        "application/vnd.gmx": ["gmx"],
        "application/vnd.google-apps.document": ["gdoc"],
        "application/vnd.google-apps.presentation": ["gslides"],
        "application/vnd.google-apps.spreadsheet": ["gsheet"],
        "application/vnd.google-earth.kml+xml": ["kml"],
        "application/vnd.google-earth.kmz": ["kmz"],
        "application/vnd.grafeq": ["gqf", "gqs"],
        "application/vnd.groove-account": ["gac"],
        "application/vnd.groove-help": ["ghf"],
        "application/vnd.groove-identity-message": ["gim"],
        "application/vnd.groove-injector": ["grv"],
        "application/vnd.groove-tool-message": ["gtm"],
        "application/vnd.groove-tool-template": ["tpl"],
        "application/vnd.groove-vcard": ["vcg"],
        "application/vnd.hal+xml": ["hal"],
        "application/vnd.handheld-entertainment+xml": ["zmm"],
        "application/vnd.hbci": ["hbci"],
        "application/vnd.hhe.lesson-player": ["les"],
        "application/vnd.hp-hpgl": ["hpgl"],
        "application/vnd.hp-hpid": ["hpid"],
        "application/vnd.hp-hps": ["hps"],
        "application/vnd.hp-jlyt": ["jlt"],
        "application/vnd.hp-pcl": ["pcl"],
        "application/vnd.hp-pclxl": ["pclxl"],
        "application/vnd.hydrostatix.sof-data": ["sfd-hdstx"],
        "application/vnd.ibm.minipay": ["mpy"],
        "application/vnd.ibm.modcap": ["afp", "listafp", "list3820"],
        "application/vnd.ibm.rights-management": ["irm"],
        "application/vnd.ibm.secure-container": ["sc"],
        "application/vnd.iccprofile": ["icc", "icm"],
        "application/vnd.igloader": ["igl"],
        "application/vnd.immervision-ivp": ["ivp"],
        "application/vnd.immervision-ivu": ["ivu"],
        "application/vnd.insors.igm": ["igm"],
        "application/vnd.intercon.formnet": ["xpw", "xpx"],
        "application/vnd.intergeo": ["i2g"],
        "application/vnd.intu.qbo": ["qbo"],
        "application/vnd.intu.qfx": ["qfx"],
        "application/vnd.ipunplugged.rcprofile": ["rcprofile"],
        "application/vnd.irepository.package+xml": ["irp"],
        "application/vnd.is-xpr": ["xpr"],
        "application/vnd.isac.fcs": ["fcs"],
        "application/vnd.jam": ["jam"],
        "application/vnd.jcp.javame.midlet-rms": ["rms"],
        "application/vnd.jisp": ["jisp"],
        "application/vnd.joost.joda-archive": ["joda"],
        "application/vnd.kahootz": ["ktz", "ktr"],
        "application/vnd.kde.karbon": ["karbon"],
        "application/vnd.kde.kchart": ["chrt"],
        "application/vnd.kde.kformula": ["kfo"],
        "application/vnd.kde.kivio": ["flw"],
        "application/vnd.kde.kontour": ["kon"],
        "application/vnd.kde.kpresenter": ["kpr", "kpt"],
        "application/vnd.kde.kspread": ["ksp"],
        "application/vnd.kde.kword": ["kwd", "kwt"],
        "application/vnd.kenameaapp": ["htke"],
        "application/vnd.kidspiration": ["kia"],
        "application/vnd.kinar": ["kne", "knp"],
        "application/vnd.koan": ["skp", "skd", "skt", "skm"],
        "application/vnd.kodak-descriptor": ["sse"],
        "application/vnd.las.las+xml": ["lasxml"],
        "application/vnd.llamagraphics.life-balance.desktop": ["lbd"],
        "application/vnd.llamagraphics.life-balance.exchange+xml": ["lbe"],
        "application/vnd.lotus-1-2-3": ["123"],
        "application/vnd.lotus-approach": ["apr"],
        "application/vnd.lotus-freelance": ["pre"],
        "application/vnd.lotus-notes": ["nsf"],
        "application/vnd.lotus-organizer": ["org"],
        "application/vnd.lotus-screencam": ["scm"],
        "application/vnd.lotus-wordpro": ["lwp"],
        "application/vnd.macports.portpkg": ["portpkg"],
        "application/vnd.mcd": ["mcd"],
        "application/vnd.medcalcdata": ["mc1"],
        "application/vnd.mediastation.cdkey": ["cdkey"],
        "application/vnd.mfer": ["mwf"],
        "application/vnd.mfmp": ["mfm"],
        "application/vnd.micrografx.flo": ["flo"],
        "application/vnd.micrografx.igx": ["igx"],
        "application/vnd.mif": ["mif"],
        "application/vnd.mobius.daf": ["daf"],
        "application/vnd.mobius.dis": ["dis"],
        "application/vnd.mobius.mbk": ["mbk"],
        "application/vnd.mobius.mqy": ["mqy"],
        "application/vnd.mobius.msl": ["msl"],
        "application/vnd.mobius.plc": ["plc"],
        "application/vnd.mobius.txf": ["txf"],
        "application/vnd.mophun.application": ["mpn"],
        "application/vnd.mophun.certificate": ["mpc"],
        "application/vnd.mozilla.xul+xml": ["xul"],
        "application/vnd.ms-artgalry": ["cil"],
        "application/vnd.ms-cab-compressed": ["cab"],
        "application/vnd.ms-excel": ["xls", "xlm", "xla", "xlc", "xlt", "xlw"],
        "application/vnd.ms-excel.addin.macroenabled.12": ["xlam"],
        "application/vnd.ms-excel.sheet.binary.macroenabled.12": ["xlsb"],
        "application/vnd.ms-excel.sheet.macroenabled.12": ["xlsm"],
        "application/vnd.ms-excel.template.macroenabled.12": ["xltm"],
        "application/vnd.ms-fontobject": ["eot"],
        "application/vnd.ms-htmlhelp": ["chm"],
        "application/vnd.ms-ims": ["ims"],
        "application/vnd.ms-lrm": ["lrm"],
        "application/vnd.ms-officetheme": ["thmx"],
        "application/vnd.ms-outlook": ["msg"],
        "application/vnd.ms-pki.seccat": ["cat"],
        "application/vnd.ms-pki.stl": ["stl"],
        "application/vnd.ms-powerpoint": ["ppt", "pps", "pot"],
        "application/vnd.ms-powerpoint.addin.macroenabled.12": ["ppam"],
        "application/vnd.ms-powerpoint.presentation.macroenabled.12": ["pptm"],
        "application/vnd.ms-powerpoint.slide.macroenabled.12": ["sldm"],
        "application/vnd.ms-powerpoint.slideshow.macroenabled.12": ["ppsm"],
        "application/vnd.ms-powerpoint.template.macroenabled.12": ["potm"],
        "application/vnd.ms-project": ["mpp", "mpt"],
        "application/vnd.ms-word.document.macroenabled.12": ["docm"],
        "application/vnd.ms-word.template.macroenabled.12": ["dotm"],
        "application/vnd.ms-works": ["wps", "wks", "wcm", "wdb"],
        "application/vnd.ms-wpl": ["wpl"],
        "application/vnd.ms-xpsdocument": ["xps"],
        "application/vnd.mseq": ["mseq"],
        "application/vnd.musician": ["mus"],
        "application/vnd.muvee.style": ["msty"],
        "application/vnd.mynfc": ["taglet"],
        "application/vnd.neurolanguage.nlu": ["nlu"],
        "application/vnd.nitf": ["ntf", "nitf"],
        "application/vnd.noblenet-directory": ["nnd"],
        "application/vnd.noblenet-sealer": ["nns"],
        "application/vnd.noblenet-web": ["nnw"],
        "application/vnd.nokia.n-gage.data": ["ngdat"],
        "application/vnd.nokia.n-gage.symbian.install": ["n-gage"],
        "application/vnd.nokia.radio-preset": ["rpst"],
        "application/vnd.nokia.radio-presets": ["rpss"],
        "application/vnd.novadigm.edm": ["edm"],
        "application/vnd.novadigm.edx": ["edx"],
        "application/vnd.novadigm.ext": ["ext"],
        "application/vnd.oasis.opendocument.chart": ["odc"],
        "application/vnd.oasis.opendocument.chart-template": ["otc"],
        "application/vnd.oasis.opendocument.database": ["odb"],
        "application/vnd.oasis.opendocument.formula": ["odf"],
        "application/vnd.oasis.opendocument.formula-template": ["odft"],
        "application/vnd.oasis.opendocument.graphics": ["odg"],
        "application/vnd.oasis.opendocument.graphics-template": ["otg"],
        "application/vnd.oasis.opendocument.image": ["odi"],
        "application/vnd.oasis.opendocument.image-template": ["oti"],
        "application/vnd.oasis.opendocument.presentation": ["odp"],
        "application/vnd.oasis.opendocument.presentation-template": ["otp"],
        "application/vnd.oasis.opendocument.spreadsheet": ["ods"],
        "application/vnd.oasis.opendocument.spreadsheet-template": ["ots"],
        "application/vnd.oasis.opendocument.text": ["odt"],
        "application/vnd.oasis.opendocument.text-master": ["odm"],
        "application/vnd.oasis.opendocument.text-template": ["ott"],
        "application/vnd.oasis.opendocument.text-web": ["oth"],
        "application/vnd.olpc-sugar": ["xo"],
        "application/vnd.oma.dd2+xml": ["dd2"],
        "application/vnd.openofficeorg.extension": ["oxt"],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": ["pptx"],
        "application/vnd.openxmlformats-officedocument.presentationml.slide": ["sldx"],
        "application/vnd.openxmlformats-officedocument.presentationml.slideshow": ["ppsx"],
        "application/vnd.openxmlformats-officedocument.presentationml.template": ["potx"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.template": ["xltx"],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ["docx"],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template": ["dotx"],
        "application/vnd.osgeo.mapguide.package": ["mgp"],
        "application/vnd.osgi.dp": ["dp"],
        "application/vnd.osgi.subsystem": ["esa"],
        "application/vnd.palm": ["pdb", "pqa", "oprc"],
        "application/vnd.pawaafile": ["paw"],
        "application/vnd.pg.format": ["str"],
        "application/vnd.pg.osasli": ["ei6"],
        "application/vnd.picsel": ["efif"],
        "application/vnd.pmi.widget": ["wg"],
        "application/vnd.pocketlearn": ["plf"],
        "application/vnd.powerbuilder6": ["pbd"],
        "application/vnd.previewsystems.box": ["box"],
        "application/vnd.proteus.magazine": ["mgz"],
        "application/vnd.publishare-delta-tree": ["qps"],
        "application/vnd.pvi.ptid1": ["ptid"],
        "application/vnd.quark.quarkxpress": ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"],
        "application/vnd.realvnc.bed": ["bed"],
        "application/vnd.recordare.musicxml": ["mxl"],
        "application/vnd.recordare.musicxml+xml": ["musicxml"],
        "application/vnd.rig.cryptonote": ["cryptonote"],
        "application/vnd.rim.cod": ["cod"],
        "application/vnd.rn-realmedia": ["rm"],
        "application/vnd.rn-realmedia-vbr": ["rmvb"],
        "application/vnd.route66.link66+xml": ["link66"],
        "application/vnd.sailingtracker.track": ["st"],
        "application/vnd.seemail": ["see"],
        "application/vnd.sema": ["sema"],
        "application/vnd.semd": ["semd"],
        "application/vnd.semf": ["semf"],
        "application/vnd.shana.informed.formdata": ["ifm"],
        "application/vnd.shana.informed.formtemplate": ["itp"],
        "application/vnd.shana.informed.interchange": ["iif"],
        "application/vnd.shana.informed.package": ["ipk"],
        "application/vnd.simtech-mindmapper": ["twd", "twds"],
        "application/vnd.smaf": ["mmf"],
        "application/vnd.smart.teacher": ["teacher"],
        "application/vnd.solent.sdkm+xml": ["sdkm", "sdkd"],
        "application/vnd.spotfire.dxp": ["dxp"],
        "application/vnd.spotfire.sfs": ["sfs"],
        "application/vnd.stardivision.calc": ["sdc"],
        "application/vnd.stardivision.draw": ["sda"],
        "application/vnd.stardivision.impress": ["sdd"],
        "application/vnd.stardivision.math": ["smf"],
        "application/vnd.stardivision.writer": ["sdw", "vor"],
        "application/vnd.stardivision.writer-global": ["sgl"],
        "application/vnd.stepmania.package": ["smzip"],
        "application/vnd.stepmania.stepchart": ["sm"],
        "application/vnd.sun.wadl+xml": ["wadl"],
        "application/vnd.sun.xml.calc": ["sxc"],
        "application/vnd.sun.xml.calc.template": ["stc"],
        "application/vnd.sun.xml.draw": ["sxd"],
        "application/vnd.sun.xml.draw.template": ["std"],
        "application/vnd.sun.xml.impress": ["sxi"],
        "application/vnd.sun.xml.impress.template": ["sti"],
        "application/vnd.sun.xml.math": ["sxm"],
        "application/vnd.sun.xml.writer": ["sxw"],
        "application/vnd.sun.xml.writer.global": ["sxg"],
        "application/vnd.sun.xml.writer.template": ["stw"],
        "application/vnd.sus-calendar": ["sus", "susp"],
        "application/vnd.svd": ["svd"],
        "application/vnd.symbian.install": ["sis", "sisx"],
        "application/vnd.syncml+xml": ["xsm"],
        "application/vnd.syncml.dm+wbxml": ["bdm"],
        "application/vnd.syncml.dm+xml": ["xdm"],
        "application/vnd.tao.intent-module-archive": ["tao"],
        "application/vnd.tcpdump.pcap": ["pcap", "cap", "dmp"],
        "application/vnd.tmobile-livetv": ["tmo"],
        "application/vnd.trid.tpt": ["tpt"],
        "application/vnd.triscape.mxs": ["mxs"],
        "application/vnd.trueapp": ["tra"],
        "application/vnd.ufdl": ["ufd", "ufdl"],
        "application/vnd.uiq.theme": ["utz"],
        "application/vnd.umajin": ["umj"],
        "application/vnd.unity": ["unityweb"],
        "application/vnd.uoml+xml": ["uoml"],
        "application/vnd.vcx": ["vcx"],
        "application/vnd.visio": ["vsd", "vst", "vss", "vsw"],
        "application/vnd.visionary": ["vis"],
        "application/vnd.vsf": ["vsf"],
        "application/vnd.wap.wbxml": ["wbxml"],
        "application/vnd.wap.wmlc": ["wmlc"],
        "application/vnd.wap.wmlscriptc": ["wmlsc"],
        "application/vnd.webturbo": ["wtb"],
        "application/vnd.wolfram.player": ["nbp"],
        "application/vnd.wordperfect": ["wpd"],
        "application/vnd.wqd": ["wqd"],
        "application/vnd.wt.stf": ["stf"],
        "application/vnd.xara": ["xar"],
        "application/vnd.xfdl": ["xfdl"],
        "application/vnd.yamaha.hv-dic": ["hvd"],
        "application/vnd.yamaha.hv-script": ["hvs"],
        "application/vnd.yamaha.hv-voice": ["hvp"],
        "application/vnd.yamaha.openscoreformat": ["osf"],
        "application/vnd.yamaha.openscoreformat.osfpvg+xml": ["osfpvg"],
        "application/vnd.yamaha.smaf-audio": ["saf"],
        "application/vnd.yamaha.smaf-phrase": ["spf"],
        "application/vnd.yellowriver-custom-menu": ["cmp"],
        "application/vnd.zul": ["zir", "zirz"],
        "application/vnd.zzazz.deck+xml": ["zaz"],
        "application/x-7z-compressed": ["7z"],
        "application/x-abiword": ["abw"],
        "application/x-ace-compressed": ["ace"],
        "application/x-apple-diskimage": ["*dmg"],
        "application/x-arj": ["arj"],
        "application/x-authorware-bin": ["aab", "x32", "u32", "vox"],
        "application/x-authorware-map": ["aam"],
        "application/x-authorware-seg": ["aas"],
        "application/x-bcpio": ["bcpio"],
        "application/x-bdoc": ["*bdoc"],
        "application/x-bittorrent": ["torrent"],
        "application/x-blorb": ["blb", "blorb"],
        "application/x-bzip": ["bz"],
        "application/x-bzip2": ["bz2", "boz"],
        "application/x-cbr": ["cbr", "cba", "cbt", "cbz", "cb7"],
        "application/x-cdlink": ["vcd"],
        "application/x-cfs-compressed": ["cfs"],
        "application/x-chat": ["chat"],
        "application/x-chess-pgn": ["pgn"],
        "application/x-chrome-extension": ["crx"],
        "application/x-cocoa": ["cco"],
        "application/x-conference": ["nsc"],
        "application/x-cpio": ["cpio"],
        "application/x-csh": ["csh"],
        "application/x-debian-package": ["*deb", "udeb"],
        "application/x-dgc-compressed": ["dgc"],
        "application/x-director": ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"],
        "application/x-doom": ["wad"],
        "application/x-dtbncx+xml": ["ncx"],
        "application/x-dtbook+xml": ["dtb"],
        "application/x-dtbresource+xml": ["res"],
        "application/x-dvi": ["dvi"],
        "application/x-envoy": ["evy"],
        "application/x-eva": ["eva"],
        "application/x-font-bdf": ["bdf"],
        "application/x-font-ghostscript": ["gsf"],
        "application/x-font-linux-psf": ["psf"],
        "application/x-font-pcf": ["pcf"],
        "application/x-font-snf": ["snf"],
        "application/x-font-type1": ["pfa", "pfb", "pfm", "afm"],
        "application/x-freearc": ["arc"],
        "application/x-futuresplash": ["spl"],
        "application/x-gca-compressed": ["gca"],
        "application/x-glulx": ["ulx"],
        "application/x-gnumeric": ["gnumeric"],
        "application/x-gramps-xml": ["gramps"],
        "application/x-gtar": ["gtar"],
        "application/x-hdf": ["hdf"],
        "application/x-httpd-php": ["php"],
        "application/x-install-instructions": ["install"],
        "application/x-iso9660-image": ["*iso"],
        "application/x-java-archive-diff": ["jardiff"],
        "application/x-java-jnlp-file": ["jnlp"],
        "application/x-latex": ["latex"],
        "application/x-lua-bytecode": ["luac"],
        "application/x-lzh-compressed": ["lzh", "lha"],
        "application/x-makeself": ["run"],
        "application/x-mie": ["mie"],
        "application/x-mobipocket-ebook": ["prc", "mobi"],
        "application/x-ms-application": ["application"],
        "application/x-ms-shortcut": ["lnk"],
        "application/x-ms-wmd": ["wmd"],
        "application/x-ms-wmz": ["wmz"],
        "application/x-ms-xbap": ["xbap"],
        "application/x-msaccess": ["mdb"],
        "application/x-msbinder": ["obd"],
        "application/x-mscardfile": ["crd"],
        "application/x-msclip": ["clp"],
        "application/x-msdos-program": ["*exe"],
        "application/x-msdownload": ["*exe", "*dll", "com", "bat", "*msi"],
        "application/x-msmediaview": ["mvb", "m13", "m14"],
        "application/x-msmetafile": ["*wmf", "*wmz", "*emf", "emz"],
        "application/x-msmoney": ["mny"],
        "application/x-mspublisher": ["pub"],
        "application/x-msschedule": ["scd"],
        "application/x-msterminal": ["trm"],
        "application/x-mswrite": ["wri"],
        "application/x-netcdf": ["nc", "cdf"],
        "application/x-ns-proxy-autoconfig": ["pac"],
        "application/x-nzb": ["nzb"],
        "application/x-perl": ["pl", "pm"],
        "application/x-pilot": ["*prc", "*pdb"],
        "application/x-pkcs12": ["p12", "pfx"],
        "application/x-pkcs7-certificates": ["p7b", "spc"],
        "application/x-pkcs7-certreqresp": ["p7r"],
        "application/x-rar-compressed": ["rar"],
        "application/x-redhat-package-manager": ["rpm"],
        "application/x-research-info-systems": ["ris"],
        "application/x-sea": ["sea"],
        "application/x-sh": ["sh"],
        "application/x-shar": ["shar"],
        "application/x-shockwave-flash": ["swf"],
        "application/x-silverlight-app": ["xap"],
        "application/x-sql": ["sql"],
        "application/x-stuffit": ["sit"],
        "application/x-stuffitx": ["sitx"],
        "application/x-subrip": ["srt"],
        "application/x-sv4cpio": ["sv4cpio"],
        "application/x-sv4crc": ["sv4crc"],
        "application/x-t3vm-image": ["t3"],
        "application/x-tads": ["gam"],
        "application/x-tar": ["tar"],
        "application/x-tcl": ["tcl", "tk"],
        "application/x-tex": ["tex"],
        "application/x-tex-tfm": ["tfm"],
        "application/x-texinfo": ["texinfo", "texi"],
        "application/x-tgif": ["obj"],
        "application/x-ustar": ["ustar"],
        "application/x-virtualbox-hdd": ["hdd"],
        "application/x-virtualbox-ova": ["ova"],
        "application/x-virtualbox-ovf": ["ovf"],
        "application/x-virtualbox-vbox": ["vbox"],
        "application/x-virtualbox-vbox-extpack": ["vbox-extpack"],
        "application/x-virtualbox-vdi": ["vdi"],
        "application/x-virtualbox-vhd": ["vhd"],
        "application/x-virtualbox-vmdk": ["vmdk"],
        "application/x-wais-source": ["src"],
        "application/x-web-app-manifest+json": ["webapp"],
        "application/x-x509-ca-cert": ["der", "crt", "pem"],
        "application/x-xfig": ["fig"],
        "application/x-xliff+xml": ["xlf"],
        "application/x-xpinstall": ["xpi"],
        "application/x-xz": ["xz"],
        "application/x-zmachine": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"],
        "audio/vnd.dece.audio": ["uva", "uvva"],
        "audio/vnd.digital-winds": ["eol"],
        "audio/vnd.dra": ["dra"],
        "audio/vnd.dts": ["dts"],
        "audio/vnd.dts.hd": ["dtshd"],
        "audio/vnd.lucent.voice": ["lvp"],
        "audio/vnd.ms-playready.media.pya": ["pya"],
        "audio/vnd.nuera.ecelp4800": ["ecelp4800"],
        "audio/vnd.nuera.ecelp7470": ["ecelp7470"],
        "audio/vnd.nuera.ecelp9600": ["ecelp9600"],
        "audio/vnd.rip": ["rip"],
        "audio/x-aac": ["aac"],
        "audio/x-aiff": ["aif", "aiff", "aifc"],
        "audio/x-caf": ["caf"],
        "audio/x-flac": ["flac"],
        "audio/x-m4a": ["*m4a"],
        "audio/x-matroska": ["mka"],
        "audio/x-mpegurl": ["m3u"],
        "audio/x-ms-wax": ["wax"],
        "audio/x-ms-wma": ["wma"],
        "audio/x-pn-realaudio": ["ram", "ra"],
        "audio/x-pn-realaudio-plugin": ["rmp"],
        "audio/x-realaudio": ["*ra"],
        "audio/x-wav": ["*wav"],
        "chemical/x-cdx": ["cdx"],
        "chemical/x-cif": ["cif"],
        "chemical/x-cmdf": ["cmdf"],
        "chemical/x-cml": ["cml"],
        "chemical/x-csml": ["csml"],
        "chemical/x-xyz": ["xyz"],
        "image/prs.btif": ["btif"],
        "image/prs.pti": ["pti"],
        "image/vnd.adobe.photoshop": ["psd"],
        "image/vnd.airzip.accelerator.azv": ["azv"],
        "image/vnd.dece.graphic": ["uvi", "uvvi", "uvg", "uvvg"],
        "image/vnd.djvu": ["djvu", "djv"],
        "image/vnd.dvb.subtitle": ["*sub"],
        "image/vnd.dwg": ["dwg"],
        "image/vnd.dxf": ["dxf"],
        "image/vnd.fastbidsheet": ["fbs"],
        "image/vnd.fpx": ["fpx"],
        "image/vnd.fst": ["fst"],
        "image/vnd.fujixerox.edmics-mmr": ["mmr"],
        "image/vnd.fujixerox.edmics-rlc": ["rlc"],
        "image/vnd.microsoft.icon": ["ico"],
        "image/vnd.ms-modi": ["mdi"],
        "image/vnd.ms-photo": ["wdp"],
        "image/vnd.net-fpx": ["npx"],
        "image/vnd.tencent.tap": ["tap"],
        "image/vnd.valve.source.texture": ["vtf"],
        "image/vnd.wap.wbmp": ["wbmp"],
        "image/vnd.xiff": ["xif"],
        "image/vnd.zbrush.pcx": ["pcx"],
        "image/x-3ds": ["3ds"],
        "image/x-cmu-raster": ["ras"],
        "image/x-cmx": ["cmx"],
        "image/x-freehand": ["fh", "fhc", "fh4", "fh5", "fh7"],
        "image/x-icon": ["*ico"],
        "image/x-jng": ["jng"],
        "image/x-mrsid-image": ["sid"],
        "image/x-ms-bmp": ["*bmp"],
        "image/x-pcx": ["*pcx"],
        "image/x-pict": ["pic", "pct"],
        "image/x-portable-anymap": ["pnm"],
        "image/x-portable-bitmap": ["pbm"],
        "image/x-portable-graymap": ["pgm"],
        "image/x-portable-pixmap": ["ppm"],
        "image/x-rgb": ["rgb"],
        "image/x-tga": ["tga"],
        "image/x-xbitmap": ["xbm"],
        "image/x-xpixmap": ["xpm"],
        "image/x-xwindowdump": ["xwd"],
        "message/vnd.wfa.wsc": ["wsc"],
        "model/vnd.collada+xml": ["dae"],
        "model/vnd.dwf": ["dwf"],
        "model/vnd.gdl": ["gdl"],
        "model/vnd.gtw": ["gtw"],
        "model/vnd.mts": ["mts"],
        "model/vnd.vtu": ["vtu"],
        "text/prs.lines.tag": ["dsc"],
        "text/vnd.curl": ["curl"],
        "text/vnd.curl.dcurl": ["dcurl"],
        "text/vnd.curl.mcurl": ["mcurl"],
        "text/vnd.curl.scurl": ["scurl"],
        "text/vnd.dvb.subtitle": ["sub"],
        "text/vnd.fly": ["fly"],
        "text/vnd.fmi.flexstor": ["flx"],
        "text/vnd.graphviz": ["gv"],
        "text/vnd.in3d.3dml": ["3dml"],
        "text/vnd.in3d.spot": ["spot"],
        "text/vnd.sun.j2me.app-descriptor": ["jad"],
        "text/vnd.wap.wml": ["wml"],
        "text/vnd.wap.wmlscript": ["wmls"],
        "text/x-asm": ["s", "asm"],
        "text/x-c": ["c", "cc", "cxx", "cpp", "h", "hh", "dic"],
        "text/x-component": ["htc"],
        "text/x-fortran": ["f", "for", "f77", "f90"],
        "text/x-handlebars-template": ["hbs"],
        "text/x-java-source": ["java"],
        "text/x-lua": ["lua"],
        "text/x-markdown": ["mkd"],
        "text/x-nfo": ["nfo"],
        "text/x-opml": ["opml"],
        "text/x-org": ["*org"],
        "text/x-pascal": ["p", "pas"],
        "text/x-processing": ["pde"],
        "text/x-sass": ["sass"],
        "text/x-scss": ["scss"],
        "text/x-setext": ["etx"],
        "text/x-sfv": ["sfv"],
        "text/x-suse-ymp": ["ymp"],
        "text/x-uuencode": ["uu"],
        "text/x-vcalendar": ["vcs"],
        "text/x-vcard": ["vcf"],
        "video/vnd.dece.hd": ["uvh", "uvvh"],
        "video/vnd.dece.mobile": ["uvm", "uvvm"],
        "video/vnd.dece.pd": ["uvp", "uvvp"],
        "video/vnd.dece.sd": ["uvs", "uvvs"],
        "video/vnd.dece.video": ["uvv", "uvvv"],
        "video/vnd.dvb.file": ["dvb"],
        "video/vnd.fvt": ["fvt"],
        "video/vnd.mpegurl": ["mxu", "m4u"],
        "video/vnd.ms-playready.media.pyv": ["pyv"],
        "video/vnd.uvvu.mp4": ["uvu", "uvvu"],
        "video/vnd.vivo": ["viv"],
        "video/x-f4v": ["f4v"],
        "video/x-fli": ["fli"],
        "video/x-flv": ["flv"],
        "video/x-m4v": ["m4v"],
        "video/x-matroska": ["mkv", "mk3d", "mks"],
        "video/x-mng": ["mng"],
        "video/x-ms-asf": ["asf", "asx"],
        "video/x-ms-vob": ["vob"],
        "video/x-ms-wm": ["wm"],
        "video/x-ms-wmv": ["wmv"],
        "video/x-ms-wmx": ["wmx"],
        "video/x-ms-wvx": ["wvx"],
        "video/x-msvideo": ["avi"],
        "video/x-sgi-movie": ["movie"],
        "video/x-smv": ["smv"],
        "x-conference/x-cooltalk": ["ice"]
      }
    }, {}], 4: [function (a, i, p) {
      i.exports = {
        "application/andrew-inset": ["ez"],
        "application/applixware": ["aw"],
        "application/atom+xml": ["atom"],
        "application/atomcat+xml": ["atomcat"],
        "application/atomsvc+xml": ["atomsvc"],
        "application/bdoc": ["bdoc"],
        "application/ccxml+xml": ["ccxml"],
        "application/cdmi-capability": ["cdmia"],
        "application/cdmi-container": ["cdmic"],
        "application/cdmi-domain": ["cdmid"],
        "application/cdmi-object": ["cdmio"],
        "application/cdmi-queue": ["cdmiq"],
        "application/cu-seeme": ["cu"],
        "application/dash+xml": ["mpd"],
        "application/davmount+xml": ["davmount"],
        "application/docbook+xml": ["dbk"],
        "application/dssc+der": ["dssc"],
        "application/dssc+xml": ["xdssc"],
        "application/ecmascript": ["ecma", "es"],
        "application/emma+xml": ["emma"],
        "application/epub+zip": ["epub"],
        "application/exi": ["exi"],
        "application/font-tdpfr": ["pfr"],
        "application/geo+json": ["geojson"],
        "application/gml+xml": ["gml"],
        "application/gpx+xml": ["gpx"],
        "application/gxf": ["gxf"],
        "application/gzip": ["gz"],
        "application/hjson": ["hjson"],
        "application/hyperstudio": ["stk"],
        "application/inkml+xml": ["ink", "inkml"],
        "application/ipfix": ["ipfix"],
        "application/java-archive": ["jar", "war", "ear"],
        "application/java-serialized-object": ["ser"],
        "application/java-vm": ["class"],
        "application/javascript": ["js", "mjs"],
        "application/json": ["json", "map"],
        "application/json5": ["json5"],
        "application/jsonml+json": ["jsonml"],
        "application/ld+json": ["jsonld"],
        "application/lost+xml": ["lostxml"],
        "application/mac-binhex40": ["hqx"],
        "application/mac-compactpro": ["cpt"],
        "application/mads+xml": ["mads"],
        "application/manifest+json": ["webmanifest"],
        "application/marc": ["mrc"],
        "application/marcxml+xml": ["mrcx"],
        "application/mathematica": ["ma", "nb", "mb"],
        "application/mathml+xml": ["mathml"],
        "application/mbox": ["mbox"],
        "application/mediaservercontrol+xml": ["mscml"],
        "application/metalink+xml": ["metalink"],
        "application/metalink4+xml": ["meta4"],
        "application/mets+xml": ["mets"],
        "application/mods+xml": ["mods"],
        "application/mp21": ["m21", "mp21"],
        "application/mp4": ["mp4s", "m4p"],
        "application/msword": ["doc", "dot"],
        "application/mxf": ["mxf"],
        "application/octet-stream": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"],
        "application/oda": ["oda"],
        "application/oebps-package+xml": ["opf"],
        "application/ogg": ["ogx"],
        "application/omdoc+xml": ["omdoc"],
        "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"],
        "application/oxps": ["oxps"],
        "application/patch-ops-error+xml": ["xer"],
        "application/pdf": ["pdf"],
        "application/pgp-encrypted": ["pgp"],
        "application/pgp-signature": ["asc", "sig"],
        "application/pics-rules": ["prf"],
        "application/pkcs10": ["p10"],
        "application/pkcs7-mime": ["p7m", "p7c"],
        "application/pkcs7-signature": ["p7s"],
        "application/pkcs8": ["p8"],
        "application/pkix-attr-cert": ["ac"],
        "application/pkix-cert": ["cer"],
        "application/pkix-crl": ["crl"],
        "application/pkix-pkipath": ["pkipath"],
        "application/pkixcmp": ["pki"],
        "application/pls+xml": ["pls"],
        "application/postscript": ["ai", "eps", "ps"],
        "application/pskc+xml": ["pskcxml"],
        "application/raml+yaml": ["raml"],
        "application/rdf+xml": ["rdf", "owl"],
        "application/reginfo+xml": ["rif"],
        "application/relax-ng-compact-syntax": ["rnc"],
        "application/resource-lists+xml": ["rl"],
        "application/resource-lists-diff+xml": ["rld"],
        "application/rls-services+xml": ["rs"],
        "application/rpki-ghostbusters": ["gbr"],
        "application/rpki-manifest": ["mft"],
        "application/rpki-roa": ["roa"],
        "application/rsd+xml": ["rsd"],
        "application/rss+xml": ["rss"],
        "application/rtf": ["rtf"],
        "application/sbml+xml": ["sbml"],
        "application/scvp-cv-request": ["scq"],
        "application/scvp-cv-response": ["scs"],
        "application/scvp-vp-request": ["spq"],
        "application/scvp-vp-response": ["spp"],
        "application/sdp": ["sdp"],
        "application/set-payment-initiation": ["setpay"],
        "application/set-registration-initiation": ["setreg"],
        "application/shf+xml": ["shf"],
        "application/smil+xml": ["smi", "smil"],
        "application/sparql-query": ["rq"],
        "application/sparql-results+xml": ["srx"],
        "application/srgs": ["gram"],
        "application/srgs+xml": ["grxml"],
        "application/sru+xml": ["sru"],
        "application/ssdl+xml": ["ssdl"],
        "application/ssml+xml": ["ssml"],
        "application/tei+xml": ["tei", "teicorpus"],
        "application/thraud+xml": ["tfi"],
        "application/timestamped-data": ["tsd"],
        "application/voicexml+xml": ["vxml"],
        "application/wasm": ["wasm"],
        "application/widget": ["wgt"],
        "application/winhlp": ["hlp"],
        "application/wsdl+xml": ["wsdl"],
        "application/wspolicy+xml": ["wspolicy"],
        "application/xaml+xml": ["xaml"],
        "application/xcap-diff+xml": ["xdf"],
        "application/xenc+xml": ["xenc"],
        "application/xhtml+xml": ["xhtml", "xht"],
        "application/xml": ["xml", "xsl", "xsd", "rng"],
        "application/xml-dtd": ["dtd"],
        "application/xop+xml": ["xop"],
        "application/xproc+xml": ["xpl"],
        "application/xslt+xml": ["xslt"],
        "application/xspf+xml": ["xspf"],
        "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"],
        "application/yang": ["yang"],
        "application/yin+xml": ["yin"],
        "application/zip": ["zip"],
        "audio/3gpp": ["*3gpp"],
        "audio/adpcm": ["adp"],
        "audio/basic": ["au", "snd"],
        "audio/midi": ["mid", "midi", "kar", "rmi"],
        "audio/mp3": ["*mp3"],
        "audio/mp4": ["m4a", "mp4a"],
        "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"],
        "audio/ogg": ["oga", "ogg", "spx"],
        "audio/s3m": ["s3m"],
        "audio/silk": ["sil"],
        "audio/wav": ["wav"],
        "audio/wave": ["*wav"],
        "audio/webm": ["weba"],
        "audio/xm": ["xm"],
        "font/collection": ["ttc"],
        "font/otf": ["otf"],
        "font/ttf": ["ttf"],
        "font/woff": ["woff"],
        "font/woff2": ["woff2"],
        "image/aces": ["exr"],
        "image/apng": ["apng"],
        "image/bmp": ["bmp"],
        "image/cgm": ["cgm"],
        "image/dicom-rle": ["drle"],
        "image/emf": ["emf"],
        "image/fits": ["fits"],
        "image/g3fax": ["g3"],
        "image/gif": ["gif"],
        "image/heic": ["heic"],
        "image/heic-sequence": ["heics"],
        "image/heif": ["heif"],
        "image/heif-sequence": ["heifs"],
        "image/ief": ["ief"],
        "image/jls": ["jls"],
        "image/jp2": ["jp2", "jpg2"],
        "image/jpeg": ["jpeg", "jpg", "jpe"],
        "image/jpm": ["jpm"],
        "image/jpx": ["jpx", "jpf"],
        "image/ktx": ["ktx"],
        "image/png": ["png"],
        "image/sgi": ["sgi"],
        "image/svg+xml": ["svg", "svgz"],
        "image/t38": ["t38"],
        "image/tiff": ["tif", "tiff"],
        "image/tiff-fx": ["tfx"],
        "image/webp": ["webp"],
        "image/wmf": ["wmf"],
        "message/disposition-notification": ["disposition-notification"],
        "message/global": ["u8msg"],
        "message/global-delivery-status": ["u8dsn"],
        "message/global-disposition-notification": ["u8mdn"],
        "message/global-headers": ["u8hdr"],
        "message/rfc822": ["eml", "mime"],
        "model/gltf+json": ["gltf"],
        "model/gltf-binary": ["glb"],
        "model/iges": ["igs", "iges"],
        "model/mesh": ["msh", "mesh", "silo"],
        "model/vrml": ["wrl", "vrml"],
        "model/x3d+binary": ["x3db", "x3dbz"],
        "model/x3d+vrml": ["x3dv", "x3dvz"],
        "model/x3d+xml": ["x3d", "x3dz"],
        "text/cache-manifest": ["appcache", "manifest"],
        "text/calendar": ["ics", "ifb"],
        "text/coffeescript": ["coffee", "litcoffee"],
        "text/css": ["css"],
        "text/csv": ["csv"],
        "text/html": ["html", "htm", "shtml"],
        "text/jade": ["jade"],
        "text/jsx": ["jsx"],
        "text/less": ["less"],
        "text/markdown": ["markdown", "md"],
        "text/mathml": ["mml"],
        "text/n3": ["n3"],
        "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"],
        "text/richtext": ["rtx"],
        "text/rtf": ["*rtf"],
        "text/sgml": ["sgml", "sgm"],
        "text/shex": ["shex"],
        "text/slim": ["slim", "slm"],
        "text/stylus": ["stylus", "styl"],
        "text/tab-separated-values": ["tsv"],
        "text/troff": ["t", "tr", "roff", "man", "me", "ms"],
        "text/turtle": ["ttl"],
        "text/uri-list": ["uri", "uris", "urls"],
        "text/vcard": ["vcard"],
        "text/vtt": ["vtt"],
        "text/xml": ["*xml"],
        "text/yaml": ["yaml", "yml"],
        "video/3gpp": ["3gp", "3gpp"],
        "video/3gpp2": ["3g2"],
        "video/h261": ["h261"],
        "video/h263": ["h263"],
        "video/h264": ["h264"],
        "video/jpeg": ["jpgv"],
        "video/jpm": ["*jpm", "jpgm"],
        "video/mj2": ["mj2", "mjp2"],
        "video/mp2t": ["ts"],
        "video/mp4": ["mp4", "mp4v", "mpg4"],
        "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"],
        "video/ogg": ["ogv"],
        "video/quicktime": ["qt", "mov"],
        "video/webm": ["webm"]
      }
    }, {}]
  }, {}, [2])(2)
});



;(function () {

    "use strict";

    function url () {

        var baseUrl = 'https://ts.cohen-hadbarot.co.il/api/';


        return {

            rb: {
                get_public_settings      :  baseUrl + 'rb/get_public_settings',
                get_modules      :  baseUrl + 'rb/get_modules',
                get_refbooks      :  baseUrl + 'rb/get_refbooks',
                get_settings      :  baseUrl + 'rb/get_settings',
                save_settings      :  baseUrl + 'rb/save_settings'
            },

            auth: {
                login      :  baseUrl + 'auth/login'
            },

            stocks: {
                doctorStockSettings      :  baseUrl + 'stocks/doctorStockSettings',
                stockBranches      :  baseUrl + 'stocks/stockBranches',
                stockSections      :  baseUrl + 'stocks/stockSections',
            },

            users: {
                forgotPassword      :  baseUrl + 'users/forgotPassword',
                logout      :  baseUrl + 'users/logout',
                customers:  {
                    balance:baseUrl + '/users/customers/balance',
                },
                setLanguage:baseUrl + 'users/setLanguage',
                messageToAdmin: baseUrl + 'users/messageToAdmin'
            },

            appointments: {
                work_list      :  baseUrl + 'appointments/work_list',
                getDocument      :  baseUrl + 'appointments/files/',
                getInvoicesList: baseUrl + 'appointments/invoices',
                getInvoiceDocument: baseUrl + 'appointments/getDocument/',
                getListDocuments: baseUrl + '/appointments/files',
            },
        };

    };

    url.$inject = [];
    angular.module('factory.url', []).factory('url', url);

})();


;(function () {

    "use strict";

    function http ($http, $q, $sessionStorage, $localStorage, $state, toastr, authUser) {

        var request = function (method, url, data, dinamic_url, responseType) {

            var config = {
                method  : method,
                url: url,
                headers : { 'Content-Type': 'application/json'},
            };


            if (typeof authUser.data == "undefined") {
                authUser.data = {};
            }

            if(typeof dinamic_url !== "undefined"){
                if (Array.isArray(dinamic_url)) {
                    dinamic_url.map(function (item){
                        config.url+='/'+item;
                    })
                } else{
                    config.url+='/'+dinamic_url;
                }
            }


            if (authUser.data.access_token) {
                config.headers.Authorization = 'Bearer ' + authUser.data.access_token ;
            }



            if (method === 'GET') {

                config.params = data;

                if (data && data.responseType) {
                    config.responseType = data.responseType;
                }
            } else {
                config.data = data;

            }

            if (responseType === 'blob'){
                config.responseType = responseType;
            }


            var defer = $q.defer();



            $http(config).then(
                function (response) {


                    if (response.data.status === "ERROR") {
                        if (response.data.validation_Error) {
                            // toastr.error(response.data.validation_Error);
                        }
                        // toastr.error(response.data.error.message, {timeOut: 3000});
                        defer.reject(response);
                    }


                    // if (res.status === 200 || res.status === 201) {
                    //     let headers = res.headers();
                    //     var file = new Blob([res.data], {type: headers['content-type']});
                    //
                    //     var  name = (tp == 1) ? 'Додаток' : 'Акт';
                    //
                    //     saveAs(file, name || 'no name');
                    // }
                    // // check if server sent status 200 and bad response from server when user not auth
                    // if (!response.data.status && !$sessionStorage.access_token) {
                    //     // toastr.error(response.data.msg.password[0]);
                    //     defer.reject(response.data.msg.password[0]);
                    // }

                    if ((response.data && response.data.error && (response.data.error.code === 2017 || response.data.error.code === 2001 ))){
                        authUser.setData({});
                        $state.go('login');
                    }

                    else {
                      var disposition = response.headers('content-disposition');
                      var fileName = null;
                      if (disposition) {
                        if (disposition.indexOf('*=UTF-8') === -1) {
                          var result = disposition.split(';')[1].trim().split('=')[1];
                          fileName = decodeURI(result.replace(/"/g, ''));
                        } else {
                          var result = disposition.split(';')[2].trim().split('*=UTF-8')[1];
                          fileName = decodeURI(result.replace(/'/g, ''));
                        }
                      }
                        defer.resolve({ data: response.data, fileName: fileName});
                    }

                },
                function (response) {
                    if (response.status === 200) {
                        // toastr.error(response.data);
                    }
                    else if (response.status === -1) {
                        // toastr.error('Server unavailable');
                    }
                    else if (response.status === 500) {
                        // toastr.error( response.status + ' ' + response.data.message);
                    }
                    else if (response.status === 403) {
                        // toastr.error('Access denied.');
                    }
                    else {
                        // toastr.error(+ response.status + ' ' + response.statusText);
                    }
                    defer.reject(response);

                }
            );
            return defer.promise;
        };



        var requestFile = function (url, data) {
            var config = {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            };



            if (typeof authUser.data == "undefined") {
                authUser.data = {};
            }

            if(typeof dinamic_url !== "undefined"){
                if (Array.isArray(dinamic_url)) {
                    dinamic_url.map(function (item){
                        config.url+='/'+item;
                    })
                } else{
                    config.url+='/'+dinamic_url;
                }
            }



            if (authUser.data.access_token) {
                config.headers.Authorization = 'Bearer ' + authUser.data.access_token ;
            }



            var defer = $q.defer();

            $http.post(url, data, config)
                .then(
                    function (response) {
                        console.info('response', url, response);
                        if (response.data.error) {
                            // toastr.error(response.data.error);
                            defer.reject(response.data.error);
                        }
                        defer.resolve(response.data);
                    },
                    function (response) {
                        if (response.status === 200) {
                            // toastr.error('Server Error: ' + response.data);
                        }
                        else if (response.status === -1) {
                            // toastr.error('Server unavailable');
                        }
                        else if (response.status === 500) {
                            // toastr.error('Server Error: ' + response.status + ' ' + response.data.message);
                        }
                        else if (response.status === 403) {
                            // toastr.error('Access denied.');
                        }
                        else {
                            // toastr.error('Server Error: ' + response.status + ' ' + response.statusText);
                        }
                        defer.reject(response.data);
                    }
                );
            return defer.promise;
        };





        return {
            get: function (url, data, dinamic_url, responseType) {
                return request('GET', url, data, dinamic_url, responseType);
            },
            post: function (url, data, dinamic_url) {
                return request('POST', url, data, dinamic_url);
            },
            delete: function (url, data, dinamic_url) {
                return request('DELETE', url, data, dinamic_url);
            },
            put: function (url, data, dinamic_url) {
                return request('PUT', url, data, dinamic_url);
            },

            file: function (url, data) {
                return requestFile(url, data);
            }
        };




    };

    http.$inject = ['$http', '$q', '$sessionStorage', '$localStorage', '$state', 'toastr', 'authUser'];
    angular.module('factory.request', []).factory('http', http);

})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';



    angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, credentials, authUser, $translate, rb, translate, $timeout, $interval) {

    $rootScope.$state = $state;

       // // get and set languages
       //  rb.get_public_settings().then(
       //      function (res) {
       //          translate.start(res);
       //      }
       //  )

      var jsonResponse = $.getJSON("language/he.json");
      jsonResponse.then(
          function (res){
              translate.start();
          }
      )

      // var interval = $interval(function() {
      //     var jsonResponse = $.getJSON("language/he.json");

      //     if ( jsonResponse.responseJSON && angular.isObject(jsonResponse.responseJSON) && Object.keys(jsonResponse.responseJSON).length>0){
      //         $timeout(function () {
      //             $interval.cancel(interval)
      //             translate.start();
      //         },0)
      //     }
      // }, 100);










      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){


          // // check for go to state/page if user authorized or not (if he can't credentials for page then event prevented)
          if (!credentials.authorized(toState)) {
              event.preventDefault();
          }


      });

      $rootScope.$on('stateChangeError', function () {
          throw arguments[5];
      });



      if (authUser.data.access_token){
          $rootScope.userModel = authUser.data;



          $state.go('index.tabs.appointments');
      } else{
          $state.go('login');
      }



      $log.debug('runBlock end');
  }



})();

(function () {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $translateProvider) {
    $stateProvider
      .state('login', {
        url: "/login",
        templateUrl: "app/components/login/login.html",
        data: {},
        controller: "LoginController",
        controllerAs: "vm",
        auth: false,
        resolve: {},
      })
      .state('index', {
        abstract: true,
        url: "",
        templateUrl: "app/components/common/content.html",
        controller: "MainCtrl",
        controllerAs: "vm",
        auth: true,
        resolve: {
          /* @ngInject */
          getBalance: function (users, $rootScope) {
            return users.customersBalance(null, [$rootScope.userModel.user_id])
              .then(
                function (res) {
                  return res.data;
                }
              )
          }
        },
      })
      // .state('index.work-list', {
      //   url: "/work-list",
      //   templateUrl: "app/components/work-list/work-list.html",
      //   data: {},
      //   controller: "WorkListController",
      //   controllerAs: "vm",
      //   resolve: {
      //     /* @ngInject */
      //     getWorkList: function (appointments, $stateParams) {
      //       var d = new Date();
      //       getDate(d);
      //       return appointments.work_list({
      //         "appointments_date": getDate(d),
      //         "current_time": getTime(d),
      //         "mode": "client"
      //       })
      //         .then(
      //           function (res) {
      //             return res.data;
      //           }
      //         )
      //
      //
      //       function getDate(date) {
      //
      //         var dd = date.getDate();
      //         if (dd < 10) dd = '0' + dd;
      //
      //         var mm = date.getMonth() + 1;
      //         if (mm < 10) mm = '0' + mm;
      //
      //         var yy = date.getFullYear() % 100;
      //         if (yy < 10) yy = '0' + yy;
      //
      //         return mm + '/' + dd + '/' + yy;
      //       };
      //
      //       function getTime(date) {
      //         var hours = date.getHours();
      //         if (hours < 10) hours = '0' + hours;
      //         var minutes = date.getMinutes();
      //         if (minutes < 10) minutes = '0' + minutes;
      //
      //         return hours + ':' + minutes;
      //       }
      //
      //
      //     }
      //   },
      //   auth: true,
      // })
      .state('index.tabs', {
        parent: "index",
        abstract: true,
        templateUrl: "app/components/work-list/tabs.html",
        data: {},
        controller: "TabsController",
        controllerAs: "vm",
        auth: true,
      })
      .state('index.tabs.appointments', {
        url: "/appointments",
        controller: "AppointmentsController",
        templateUrl: "app/components/work-list/tab-appointments.html",
        controllerAs: "vm",
        data: {},
        resolve: {
          /* @ngInject */
          getWorkList: function (appointments, $stateParams) {
            var d = new Date();
            getDate(d);
            return appointments.work_list({
              "appointments_date": getDate(d),
              "current_time": getTime(d),
              "mode": "client"
            })
              .then(
                function (res) {
                  return res.data;
                }
              )


            function getDate(date) {

              var dd = date.getDate();
              if (dd < 10) dd = '0' + dd;

              var mm = date.getMonth() + 1;
              if (mm < 10) mm = '0' + mm;

              var yy = date.getFullYear() % 100;
              if (yy < 10) yy = '0' + yy;

              return mm + '/' + dd + '/' + yy;
            };

            function getTime(date) {
              var hours = date.getHours();
              if (hours < 10) hours = '0' + hours;
              var minutes = date.getMinutes();
              if (minutes < 10) minutes = '0' + minutes;

              return hours + ':' + minutes;
            }


          }
        },
        auth: true,
      })
      .state('index.tabs.documents', {
        parent: "index.tabs",
        url: "/documents",
        controller: "DocumentsController",
        templateUrl: "app/components/work-list/tab-documents.html",
        controllerAs: "vm",
        data: {},
        resolve: {
          /* @ngInject */
          getListResponse: function (appointments, $stateParams) {
            return appointments.getListDocuments()
              .then(
                function (res) {
                  return res.data;
                }
              )
          }
        },
        auth: true,
      })
      .state('index.tabs.invoices', {
        parent: "index.tabs",
        url: "/invoices",
        controller: "InvoicesController",
        templateUrl: "app/components/work-list/tab-invoices.html",
        controllerAs: "vm",
        data: {},
        resolve: {
          /* @ngInject */
          getInvoicesList: function (appointments, $stateParams) {
            return appointments.getInvoicesList()
              .then(
                function (res) {
                  return res.data;
                }
              )
          }
        },
        auth: true,
      })


    $urlRouterProvider.otherwise('/appointments');


    // var jsonResponse = $.getJSON("language/en.json");
    // jsonResponse.then(function (data) {
    //     let heJson = data;
    //     $translateProvider.translations('en', heJson);
    // });


    var jsonResponse = $.getJSON("language/he.json");


    jsonResponse.then(function (data) {
      var heJson = data;
      $translateProvider.translations('he', heJson);
    });


    // $translateProvider.preferredLanguage('eng');


  }


})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive('iboxToolsFullScreen', iboxToolsFullScreen)
    .directive('iboxTools', iboxTools)
    .directive('iboxUpTools', iboxUpTools)
    .directive('truncate', truncate);
    // .directive('icheck', icheck);




/**
 * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
 */
function iboxToolsFullScreen($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'app/components/common/ibox_tools.html',
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.children('.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            };
            // Function for close ibox
            $scope.closebox = function () {
                var ibox = $element.closest('div.ibox');
                ibox.remove();
            };
            // Function for full screen
            $scope.fullscreen = function () {
                var ibox = $element.closest('div.ibox');
                var button = $element.find('i.fa-expand');
                $('body').toggleClass('fullscreen-ibox-mode');
                button.toggleClass('fa-expand').toggleClass('fa-compress');
                ibox.toggleClass('fullscreen');
                setTimeout(function() {
                    $(window).trigger('resize');
                }, 100);
            }
        }
    };
}

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
function iboxUpTools($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'app/components/common/ibox_up_tools.html',
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.children('.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            };
            // Function for close ibox
            $scope.closebox = function () {
                var ibox = $element.closest('div.ibox');
                ibox.remove();
            }
            $scope.showhide2 = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.children('.ibox-content');
                content.slideToggle(0);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 0);
            };
            $scope.showhide2()

        }
    };
}





/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
function iboxTools($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'app/components/common/ibox_up_tools.html',
        controller: function ($scope, $element) {

            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.children('.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            };
            // Function for close ibox
            $scope.closebox = function () {
                var ibox = $element.closest('div.ibox');
                ibox.remove();
            }

        }
    };
}


/**
 * truncate - Directive for truncate string
 */
function truncate($timeout){
    return {
        restrict: 'A',
        scope: {
            truncateOptions: '='
        },
        link: function(scope, element) {
            $timeout(function(){
                element.dotdotdot(scope.truncateOptions);

            });
        }
    };
}






(function () {
  'use strict';

  function MainCtrl(users, authUser, auth, getBalance, $rootScope, SweetAlert, ngDialog, $translate, $q) {
    var vm = this;
    vm.dialog = ngDialog;
    vm.balance = getBalance.balance;
    vm.logout = logout;
    vm.openMessagePopup = openMessagePopup;

    vm.viewable_accounts = authUser.getData('viewable_accounts');
    vm.user = vm.viewable_accounts[0];
    $rootScope.user = vm.user;
    vm.changeUser = changeUser;

    function changeUser(new_user) {
      vm.user = new_user;
      vm.balance = vm.user.balance;
      $rootScope.user = new_user;
      $rootScope.$broadcast('changeUser', new_user);
    }

    function logout() {
      users.logout();
    }

    function openMessagePopup() {
      var thankYouMessageKey = 'Thank you for your inquiry, the company representative will contact you as soon as possible';
      var errorMessageKey = 'Sorry, some error was occurred!';
      var errorTitleKey = 'Error';
      var successTitleKey = 'Success';

      var thankYouMessage = '';
      var errorMessage = '';
      var errorTitle = '';
      var successTitle = '';
      var messageDialog;
      var setTranslations = function (listArray){
        try {
          if (!Array.isArray(listArray)) {
            throw new Error("List of translations has not proper type");
          }

          if (typeof  listArray[0] === "undefined" || Object.keys(listArray[0]).length === 0) {
            throw new Error("List of translations has not proper type");
          }

          thankYouMessage = typeof listArray[0][thankYouMessageKey] === "string" ? listArray[0][thankYouMessageKey] : thankYouMessageKey;
          errorMessage = typeof listArray[0][errorMessageKey] === "string" ? listArray[0][errorMessageKey] : errorMessageKey;
          errorTitle = typeof listArray[0][errorTitleKey] === "string" ? listArray[0][errorTitleKey] : errorTitleKey;
          successTitle = typeof listArray[0][successTitleKey] === "string" ? listArray[0][successTitleKey] : successTitleKey;
        } catch (e) {
          console.error(e);
          thankYouMessage = thankYouMessageKey;
          errorMessage = errorMessageKey;
          errorTitle = errorTitleKey;
          successTitle = successTitleKey;
        }
      };

      $q.all([
        $translate([thankYouMessageKey, errorMessageKey, errorTitleKey, successTitleKey]),
      ]).then(function (tList) {
        setTranslations(tList)
      }, function (tList) {
        setTranslations(tList);
      }).then(function () {
        messageDialog = getDialog();
      })

      function getDialog() {
        return vm.dialog.open({
          templateUrl: 'message-popup.html',
          width: 600,
          controller: ['$scope', '$timeout', '$translate', function($scope, $timeout, $translate) {
            $scope.loading = false;
            function toggleLoading () {
              $scope.loading = !$scope.loading;
            };

            $scope.cancel = messageDialog.close;
            $scope.onSubmit = function(form) {
              if (form.$valid && form.messageTextModel.value) {
                var text = form.messageTextModel.value;
                toggleLoading();
                users.messageToAdmin({
                  text: text
                }).then(
                  function(resp) {
                    toggleLoading();
                    messageDialog.close();
                    messageDialog.closePromise.then(function() {
                      SweetAlert.success(successTitle, thankYouMessage);
                    });
                  },
                  function(error) {
                    toggleLoading();
                    messageDialog.close();
                    messageDialog.closePromise.then(function() {
                      SweetAlert.error(errorTitle, errorMessage)
                    });
                  });
              }
            }
          }]
        })
      }
    }
  }

  MainCtrl.$inject = ['users', 'authUser', 'auth', 'getBalance', '$rootScope', 'SweetAlert','ngDialog', '$translate', '$q'];
  angular.module('inspinia').controller('MainCtrl', MainCtrl);
})();

;(function () {
    'use strict';

    angular.module('app.request', [
        'factory.url',
        'factory.request'
    ]);

})();
;(function () {
    'use strict';

    angular.module('app.services', [
        'model.credentials',
        'model.authUser',
        'model.auth',
        'model.goodAlert',
        'model.users',
        'model.stocks',
        'model.rb',
        'model.appointments',
        'model.translate'



    ]);

})();
/**
 * Created by alex on 24.02.2017.
 */
;(function () {
    'use strict';

    angular.module('app.filters', [

    ]);

})();



;(function () {
    'use strict';

    angular.module('app.directives', [
    ]);

})();
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div id=\"page-wrapper\" class=\"gray-bg\"><div class=\"\" ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div><script type=\"text/ng-template\" id=\"message-popup.html\"><div class=\"inmodal message-popup ibox-content\" ng-class=\"{\'sk-loading\': loading}\"> <div class=\"modal-header\"> <h4 class=\"modal-title\">{{\'Message to admin\' | translate}}</h4> <!-- <small class=\"font-bold\"></small>--> </div> <form ng-submit=\"onSubmit(messageForm)\" name=\"messageForm\" novalidate class=\"message-popup__form\"> <div class=\"modal-body\"> <div class=\"form-group form-row-message\"> <textarea name=\"messageTextModel\" required=\"true\" ng-model=\"messageForm.messageTextModel.value\" ng-class=\"{\'error\' : (messageForm.$submitted || messageForm.messageTextModel.$touched) && messageForm.messageTextModel.$error.required}\"> </textarea> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">{{\'Close\' | translate}}</button> <button type=\"submit\" class=\"btn btn-primary\">{{\'Send\' | translate}}</button> </div> </form> <div class=\"sk-spinner sk-spinner-rotating-plane\"></div> </div></script>");
$templateCache.put("app/components/common/footer.html","<div class=\"row footer\" style=\"padding:0px ;margin-left:0px; margin-right:0px;\"><div class=\"col-xs-12 text-center p-xs footer-row\" style=\"background: #00523a; font-size:12px; color:#0b9955\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span>Pest Control 2017 ©</span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span>{{\'Privacy Policy\'| translate}}</span><span></span><span>{{\'Terms &amp; Conditions\'| translate}}</span></div></div></div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-down\"></i></a></div>");
$templateCache.put("app/components/common/ibox_up_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a></div>");
$templateCache.put("app/components/common/message-popup.html","<div class=\"inmodal message-popup ibox-content\" ng-class=\"{\'sk-loading\': loading}\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{\"Message to admin\" | translate}}}</h4></div><form ng-submit=\"onSubmit(messageForm)\" name=\"messageForm\" novalidate=\"\" class=\"message-popup__form\"><div class=\"modal-body\"><div class=\"form-group form-row-message\"><textarea name=\"messageTextModel\" required=\"true\" ng-model=\"messageForm.messageTextModel.value\" ng-class=\"{\'error\' : (messageForm.$submitted || messageForm.messageTextModel.$touched) && messageForm.messageTextModel.$error.required}\">\r\n        </textarea></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">{{\"Close\"| translate}}</button> <button type=\"submit\" class=\"btn btn-primary\">Send</button></div></form><div class=\"sk-spinner sk-spinner-rotating-plane\"></div></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side white-bg\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\" ng-class=\"{\'rtl-nav\':settings.rtl_ltr}\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><div><span class=\"clear\"><span class=\"block m-t-xs\"></span> <span class=\"text-muted text-xs block\">{{vm.user.name}}</span></span></div></div><div class=\"logo-element\"><img src=\"./assets/images/favicon_32x32.png\" alt=\"\"></div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.stock-branch-bind\"><i class=\"fa fa-dashboard\"></i> <span class=\"nav-label\" translate=\"\">Stock Branch Binds</span></a></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\" style=\"margin-left:0px;margin-right:0px;\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><ul ng-class=\"{\'rtl-login-label\':(settings.rtl_ltr===\'rtl\')}\" class=\"nav navbar-top-links navbar-left pull-left login-label hidden-xs\"></ul><ul ng-class=\"{\'rtl-login-label-min\':(settings.rtl_ltr===\'rtl\')}\" class=\"nav navbar-top-links navbar-left pull-left login-label-min visible-xs hidden-xxs\"></ul><ul class=\"nav navbar-top-links navbar-right pull-right\"><li class=\"message-btn\"><a class=\"message-btn__link\" ng-click=\"vm.openMessagePopup()\"><img class=\"message-btn__image\" src=\"../../../assets/images/message-512.png\"></a></li><li><a><div style=\"color:white\"><span>{{\'Balance\' | translate}}</span><span>:</span> <span dir=\"ltr\" style=\"color:white\" ng-bind=\"vm.balance | currency:\'\'\"></span></div></a></li><li class=\"\"><a><div class=\"\" uib-dropdown=\"\"><div uib-dropdown-toggle=\"\" href=\"\"><ul style=\"padding: 0px\"><li><i ng-class=\"{\'rtl-header-pic-user\':(settings.rtl_ltr===\'rtl\')}\" class=\"header-pic-user\"></i></li><li style=\"margin:0px\"><span style=\"color:white\" class=\"text-muted text-xs block\">{{vm.user.name}}<b class=\"caret\"></b></span></li></ul></div><ul style=\"background: #00523a; margin-top: 8px;\" uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li style=\"padding:10px; color:white; text-align: right; margin:0px\" class=\"user_name\" ng-click=\"vm.changeUser(account)\" ng-repeat=\"account in vm.viewable_accounts\"><span ng-bind=\"account.name\"></span></li></ul></div></a></li><li><a ng-click=\"vm.logout()\"><div style=\"\"><i ng-class=\"{\'rtl-header-pic-logout\':(settings.rtl_ltr===\'rtl\')}\" class=\"header-pic-logout\"></i><span style=\"color:white\">{{\'Log out\' | translate}}</span></div></a></li></ul></nav></div>");
$templateCache.put("app/components/login/login.html","<div class=\"admin-login\" ng-attr-dir=\"{{settings.rtl_ltr}}\"><div class=\"languages pull-right\"><a class=\"btn btn-white set_en\" ng-click=\"vm.changeLanguage(\'he\')\"><img src=\"./assets/images/flags/16/Israel.png\"> HE</a> <a class=\"btn btn-white set_en\" ng-click=\"vm.changeLanguage(\'en\')\"><img src=\"./assets/images/flags/16/United-States.png\"> EN</a></div><div class=\"row loginColumns\" style=\"height:100vh\"><div class=\"col-xs-12 col-sm-12 text-center\"><div class=\"logo__under-form\"><div class=\"logo__img\" style=\"background-image: url(./assets/images/logo_top.bmp);\"></div></div></div><div class=\"col-xs-12 col-sm-12 text-center\"><div class=\"ibox-content\"><form ng-if=\"!vm.forgotFormShow\" class=\"\" name=\"vm.form\" novalidate=\"\" autocomplete=\"off\" ng-submit=\"vm.login()\"><div><h2 class=\"title\">{{\'Login\'| translate}}</h2></div><div class=\"form-group\"><input id=\"username\" type=\"text\" class=\"form-control\" name=\"username\" ng-model=\"vm.user.username\" required=\"\" placeholder=\"{{\'Email\' | translate}}\" autocomplete=\"off\" ng-class=\"{\'rtl\':(settings.rtl_ltr===\'rtl\')}\"><div class=\"error-block\" ng-messages=\"vm.form.username.$error\"><div ng-message=\"pattern\">{{\'Email\'}} {{\'must be\'}} {{\'a valid\'}} {{\'email\'}}</div></div></div><div class=\"form-group\"><input id=\"password\" type=\"password\" class=\"form-control\" name=\"password\" ng-model=\"vm.user.password\" required=\"\" placeholder=\"{{\'Password\' | translate}}\" autocomplete=\"off\" ng-class=\"{\'rtl\':(settings.rtl_ltr===\'rtl\')}\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-disabled=\"vm.disableBtn\">{{\'Login\' | translate}}</button> <a class=\"btn btn-link forgot-text\" ng-click=\"vm.forgotFormShow = true\">{{\'Forgot password\' | translate}}</a></form><form ng-if=\"vm.forgotFormShow\" class=\"\" name=\"vm.formForgot\" novalidate=\"\" autocomplete=\"off\" ng-submit=\"vm.forgotPassword()\"><div><h2 class=\"title\">{{\'Forgot password\'| translate}}</h2></div><div class=\"form-group\" style=\"margin-top:80px\"><input id=\"email\" type=\"text\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required=\"\" placeholder=\"{{\'Email\' | translate}}\" autocomplete=\"off\" ng-class=\"{\'rtl\':(settings.rtl_ltr===\'rtl\')}\"><div class=\"error-block\" ng-messages=\"vm.form.email.$error\"><div ng-message=\"pattern\">{{\'Email\' | translate }} {{\'must be\' | translate}} {{\'a valid\' | translate}} {{\'email\' | translate}}</div></div></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-disabled=\"vm.disableBtn\" translate=\"\">Submit</button> <a class=\"btn btn-link login-text\" translate=\"\" ng-click=\"vm.forgotFormShow = false\">Login</a></form></div></div></div><div class=\"row content-footer\"><div class=\"col-xs-12 text-center\"><div class=\"footer_picture\"></div></div><div class=\"col-xs-12 text-center p-xs\" style=\"background: #0b9955\"><div class=\"p-xss m-l-sm m-sm p-xss\"><span>{{\'If you have any questions please feel free to contact us\'| translate}}</span></div><div class=\"p-xss m-l-sm m-sm p-xss\"><span style=\"color:#9ce113\">{{\'Email\'| translate}}: rita@cohen-hadbarot.com</span></div><div class=\"p-xss m-l-sm m-sm p-xss\"><span style=\"color:#9ce113\">{{\'Phone\'|translate}} : 03-6121212</span></div></div><div class=\"col-xs-12 text-center p-xs footer-row\" style=\"background: #00523a\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span>{{\'Eli Cohen Company Ltd\' | translate}}</span> <span>2017 (с)</span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span>{{\'Privacy Policy\'| translate}}</span><span></span><span>{{\'Terms &amp; Conditions\'| translate}}</span></div></div></div></div></div>");
$templateCache.put("app/components/work-list/tab-appointments.html","<div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th rowspan=\"2\">{{\'Date\' | translate}}</th><th rowspan=\"2\">{{\'Time\' | translate}}</th><th rowspan=\"2\">{{\'Exterminator\' | translate}}</th><th colspan=\"2\">{{\'Services\' | translate}}</th><th colspan=\"4\">{{\'Materials\' | translate}}</th><th rowspan=\"2\">{{\'Total\' | translate}}</th></tr><tr><th scope=\"col\">{{\'Type of service / product\' | translate}}</th><th scope=\"col\">{{\'Sum\' | translate}}</th><th scope=\"col\">{{\'Name\' | translate}}</th><th scope=\"col\">{{\'Batch number\' | translate}}</th><th scope=\"col\">{{\'Materials used\' | translate}}</th><th scope=\"col\">{{\'Sum\' | translate}}</th></tr></thead><tbody ng-class=\"{\'odd\':$odd}\" class=\"\" ng-repeat=\"item in vm.worklist\"><tr><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\" ng-bind=\"item.Date\"></td><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\" ng-bind=\"item.StartTime.slice(0,5)\"></td><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\" ng-bind=\"item.WorkerName || \'-\'\"></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\" ng-bind=\"item.Date\"></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\" ng-bind=\"item.StartTime.slice(0,5)\"></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\" ng-bind=\"item.WorkerName || \'-\'\"></td><td ng-bind=\"item.servicesPC[0].ItemDesc || \'-\'\"></td><td ng-bind=\"item.servicesPC[0].Price || \'-\'\"></td><td ng-bind=\"item.materials[0].ItemDesc || \'-\'\"></td><td ng-bind=\"item.materials[0].BatchNum || \'-\'\"></td><td ng-bind=\"item.materials[0].Amount || \'-\'\"></td><td ng-bind=\"item.materials[0].Price || \'-\'\"></td><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\" ngmas-bind=\"item.total_amount\"></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\" ng-bind=\"item.total_amount\"></td></tr><tr ng-repeat=\"innerItem in item.servicesMaterials2\"><td ng-bind=\"innerItem.servicesPC2.ItemDesc || \'-\'\"></td><td ng-bind=\"innerItem.servicesPC2.Price || \'-\'\"></td><td ng-bind=\"innerItem.materialsPC2.ItemDesc || \'-\'\"></td><td ng-bind=\"innerItem.materialsPC2.BatchNum || \'-\'\"></td><td ng-bind=\"innerItem.materialsPC2.Amount || \'-\'\"></td><td ng-bind=\"innerItem.materialsPC2.Price || \'-\'\"></td></tr></tbody></table></div>");
$templateCache.put("app/components/work-list/tab-documents.html","<div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>{{\'Name\' | translate}}</th><th>{{\'Date\' | translate}}</th><th>{{\'Description\' | translate}}</th><th>{{\'Action\' | translate}}</th></tr></thead><tbody ng-class=\"{\'odd\':$odd}\" class=\"\" ng-repeat=\"item in vm.list\"><tr><td ng-bind=\"item.name || \'-\'\"></td><td ng-bind=\"item.date || \'-\'\"></td><td ng-bind=\"item.description || \'-\'\"></td><td><a class=\"btn btn-circle img ng-scope\" ng-if=\"!item.image\" ng-click=\"vm.getDocument(item)\"></a> <a class=\"btn btn-circle ng-scope image-icon\" ng-if=\"item.image\" ng-click=\"vm.getDocument(item)\"><i class=\"fa fa-file-image-o\" style=\"font-size: 24px; color: #337ab7;\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("app/components/work-list/tab-invoices.html","<div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>{{\'Date\' | translate}}</th><th>{{\'Number\' | translate}}</th><th>{{\'Total\' | translate}}</th><th>{{\'Action\' | translate}}</th></tr></thead><tbody ng-class=\"{\'odd\':$odd}\" class=\"\" ng-repeat=\"item in vm.list\"><tr><td ng-bind=\"item.date || \'-\'\"></td><td ng-bind=\"item.invoiceNum || \'-\'\"></td><td ng-bind=\"item.total || \'-\'\"></td><td><a class=\"btn btn-circle img ng-scope\" ng-click=\"vm.getDocument(item)\"></a></td></tr></tbody></table></div>");
$templateCache.put("app/components/work-list/tabs.html","<div class=\"wrapper wrapper-content work-list\"><ul class=\"nav nav-tabs\"><li ng-class=\"{\'active\' : $state.current.name === value.state }\" ui-sref-active=\"\" ng-repeat=\"(key, value) in vm.tabs\"><a ui-sref=\"{{value.state}}\"><i class=\"fa\" ng-class=\"{[value.iconClass]: value.iconClass}\"></i> {{value.title | translate}}</a></li></ul><div class=\"ibox-content\"><div ui-view=\"\"></div></div></div>");
$templateCache.put("app/components/work-list/work-list.html","<div class=\"wrapper wrapper-content work-list\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th rowspan=\"2\">{{\'Date\' | translate}}</th><th rowspan=\"2\">{{\'Time\' | translate}}</th><th rowspan=\"2\">{{\'Exterminator\' | translate}}</th><th colspan=\"2\">{{\'Services\' | translate}}</th><th colspan=\"2\">{{\'Materials\' | translate}}</th><th rowspan=\"2\">{{\'Total\' | translate}}</th><th rowspan=\"2\">{{\'Invoice/Receipt\' | translate}}</th></tr><tr><th scope=\"col\">{{\'Name\' | translate}}</th><th scope=\"col\">{{\'Sum\' | translate}}</th><th scope=\"col\">{{\'Name\' | translate}}</th><th scope=\"col\">{{\'Sum\' | translate}}</th></tr></thead><tbody ng-class=\"{\'odd\':$odd}\" class=\"\" ng-repeat=\"item in vm.worklist\"><tr><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\" ng-bind=\"item.Date\"></td><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\" ng-bind=\"item.StartTime.slice(0,5)\"></td><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\" ng-bind=\"item.WorkerName || \'-\'\"></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\" ng-bind=\"item.Date\"></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\" ng-bind=\"item.StartTime.slice(0,5)\"></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\" ng-bind=\"item.WorkerName || \'-\'\"></td><td ng-bind=\"item.servicesPC[0].ItemDesc || \'-\'\"></td><td ng-bind=\"item.servicesPC[0].Price || \'-\'\"></td><td ng-bind=\"item.materials[0].ItemDesc || \'-\'\"></td><td ng-bind=\"item.materials[0].Price|| \'-\'\"></td><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\" ng-bind=\"item.total_amount\"></td><td ng-if=\"item.servicesPC2 && item.servicesPC2.length>0\" rowspan=\"{{item.servicesPC2.length+1}}\"><a ng-if=\"item.isPDFGenerated\" class=\"btn btn-circle img\" ng-click=\"vm.getDocument(item)\"></a> <a ng-if=\"!item.isPDFGenerated\" style=\"opacity:0.4;\" ng-disabled=\"!item.isPDFGenerated\" class=\"btn btn-circle img\"></a></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\" ng-bind=\"item.total_amount\"></td><td ng-if=\"!item.servicesPC2 || item.servicesPC2.length<1\" rowspan=\"{{item.materialsPC2.length+1}}\"><a ng-if=\"item.isPDFGenerated\" class=\"btn btn-circle img\" ng-click=\"vm.getDocument(item)\"></a> <a ng-if=\"!item.isPDFGenerated\" style=\"opacity:0.4;\" ng-disabled=\"!item.isPDFGenerated\" class=\"btn btn-circle img\"></a></td></tr><tr ng-repeat=\"innerItem in item.servicesMaterials2\"><td ng-bind=\"innerItem.servicesPC2.ItemDesc || \'-\'\"></td><td ng-bind=\"innerItem.servicesPC2.Price || \'-\'\"></td><td ng-bind=\"innerItem.materialsPC2.ItemDesc || \'-\'\"></td><td ng-bind=\"innerItem.materialsPC2.Price || \'-\'\"></td></tr></tbody></table></div></div></div>");}]);